var items = {
  "block.minecraft.acacia_button": "Putan sitta",
  "block.minecraft.acacia_door": "Doras sitta",
  "block.minecraft.acacia_fence": "Feansa sitta",
  "block.minecraft.acacia_fence_gate": "Geata feansa sitta",
  "block.minecraft.acacia_hanging_sign": "Soidhne-crochadh sitta",
  "block.minecraft.acacia_leaves": "Duilleach sitta",
  "block.minecraft.acacia_log": "Loga sitta",
  "block.minecraft.acacia_planks": "Dèilean sitta",
  "block.minecraft.acacia_pressure_plate": "Pleata-brùthaidh sitta",
  "block.minecraft.acacia_sapling": "Fiùran sitta",
  "block.minecraft.acacia_shelf": "Sgielp sitta",
  "block.minecraft.acacia_sign": "Soidhne sitta",
  "block.minecraft.acacia_slab": "Leac sitta",
  "block.minecraft.acacia_stairs": "Staidhre sitta",
  "block.minecraft.acacia_trapdoor": "Doras-leigeil sitta",
  "block.minecraft.acacia_wall_hanging_sign": "Soidhne-crochadh bhalla sitta",
  "block.minecraft.acacia_wall_sign": "Soidhne-bhalla sitta",
  "block.minecraft.acacia_wood": "Fiodh sitta",
  "block.minecraft.activator_rail": "Rèile-gnìomhachaidh",
  "block.minecraft.air": "Adhar",
  "block.minecraft.allium": "Uinnean Pearsach",
  "block.minecraft.amethyst_block": "Bloc amaitist",
  "block.minecraft.amethyst_cluster": "Bagaid amaitist",
  "block.minecraft.ancient_debris": "Smodal àrsaidh",
  "block.minecraft.andesite": "Andasait",
  "block.minecraft.andesite_slab": "Leac andasait",
  "block.minecraft.andesite_stairs": "Staidhre andasait",
  "block.minecraft.andesite_wall": "Balla andasait",
  "block.minecraft.anvil": "Innean",
  "block.minecraft.attached_melon_stem": "Gas ceangailte meal-bhuic",
  "block.minecraft.attached_pumpkin_stem": "Gas ceangailte peapaige",
  "block.minecraft.azalea": "Asàilia",
  "block.minecraft.azalea_leaves": "Duilleach asàilia",
  "block.minecraft.azure_bluet": "Gorm-lus",
  "block.minecraft.bamboo": "Bambù",
  "block.minecraft.bamboo_block": "Bloca bambù",
  "block.minecraft.bamboo_button": "Putan bambù",
  "block.minecraft.bamboo_door": "Doras bambù",
  "block.minecraft.bamboo_fence": "Feansa bambù",
  "block.minecraft.bamboo_fence_gate": "Geata feansa bambù",
  "block.minecraft.bamboo_hanging_sign": "Soidhne-crochadh bambù",
  "block.minecraft.bamboo_mosaic": "Mosàig Bambù",
  "block.minecraft.bamboo_mosaic_slab": "Leac Mosàig Bambù",
  "block.minecraft.bamboo_mosaic_stairs": "Staidhre Mosàig Bambù",
  "block.minecraft.bamboo_planks": "Dèilean bambù",
  "block.minecraft.bamboo_pressure_plate": "Pleata-brùthaidh bambù",
  "block.minecraft.bamboo_sapling": "Cuiseag bambù",
  "block.minecraft.bamboo_shelf": "Sgielp bambù",
  "block.minecraft.bamboo_sign": "Soidhne bambù",
  "block.minecraft.bamboo_slab": "Leac bambù",
  "block.minecraft.bamboo_stairs": "Staidhre bambù",
  "block.minecraft.bamboo_trapdoor": "Doras-leigeil bambù",
  "block.minecraft.bamboo_wall_hanging_sign": "Soidhne-crochadh bhalla bambù",
  "block.minecraft.bamboo_wall_sign": "Soidhne-bhalla bambù",
  "block.minecraft.banner.base.black": "Raon gu tur dubh",
  "block.minecraft.banner.base.blue": "Raon gu tur gorm",
  "block.minecraft.banner.base.brown": "Raon gu tur donn",
  "block.minecraft.banner.base.cyan": "Raon gu tur saidhean",
  "block.minecraft.banner.base.gray": "Raon gu tur glas",
  "block.minecraft.banner.base.green": "Raon gu tur uaine",
  "block.minecraft.banner.base.light_blue": "Raon gu tur bàn-ghorm",
  "block.minecraft.banner.base.light_gray": "Raon gu tur liath",
  "block.minecraft.banner.base.lime": "Raon gu tur bàn-uaine",
  "block.minecraft.banner.base.magenta": "Raon gu tur maidèanta",
  "block.minecraft.banner.base.orange": "Raon gu tur orains",
  "block.minecraft.banner.base.pink": "Raon gu tur bàn-dearg",
  "block.minecraft.banner.base.purple": "Raon gu tur purpaidh",
  "block.minecraft.banner.base.red": "Raon gu tur dearg",
  "block.minecraft.banner.base.white": "Raon gu tur geal",
  "block.minecraft.banner.base.yellow": "Raon gu tur buidhe",
  "block.minecraft.banner.border.black": "Iomallan dubha",
  "block.minecraft.banner.border.blue": "Iomallan gorma",
  "block.minecraft.banner.border.brown": "Iomallan donna",
  "block.minecraft.banner.border.cyan": "Iomallan saidhean",
  "block.minecraft.banner.border.gray": "Iomallan liatha",
  "block.minecraft.banner.border.green": "Iomallan uaine",
  "block.minecraft.banner.border.light_blue": "Iomallan shoilleir-ghorma",
  "block.minecraft.banner.border.light_gray": "Iomallan soilleir-liatha",
  "block.minecraft.banner.border.lime": "Iomallan dath na liomaid",
  "block.minecraft.banner.border.magenta": "Iomallan magenta",
  "block.minecraft.banner.border.orange": "Iomallan orains",
  "block.minecraft.banner.border.pink": "Iomallan pince",
  "block.minecraft.banner.border.purple": "Iomallan purpaidh",
  "block.minecraft.banner.border.red": "Iomallan dearga",
  "block.minecraft.banner.border.white": "Iomallan geala",
  "block.minecraft.banner.border.yellow": "Iomallan buidhe",
  "block.minecraft.banner.bricks.black": "Breigichean dubha",
  "block.minecraft.banner.bricks.blue": "Breigichean gorma",
  "block.minecraft.banner.bricks.brown": "Breigichean donna",
  "block.minecraft.banner.bricks.cyan": "Breigichean saidhean",
  "block.minecraft.banner.bricks.gray": "Breigichean liatha",
  "block.minecraft.banner.bricks.green": "Breigichean uaine",
  "block.minecraft.banner.bricks.light_blue": "Breigichean soilleir-ghorma",
  "block.minecraft.banner.bricks.light_gray": "Breigichean soilleir-liatha",
  "block.minecraft.banner.bricks.lime": "Breigichean dath na liomaid",
  "block.minecraft.banner.bricks.magenta": "Breigichean magenta",
  "block.minecraft.banner.bricks.orange": "Breigichean orains",
  "block.minecraft.banner.bricks.pink": "Breigichean pince",
  "block.minecraft.banner.bricks.purple": "Breigichean purpaidh",
  "block.minecraft.banner.bricks.red": "Breigichean dearga",
  "block.minecraft.banner.bricks.white": "Breigichean geala",
  "block.minecraft.banner.bricks.yellow": "Breigichean buidhe",
  "block.minecraft.banner.circle.black": "Cearcall dubh",
  "block.minecraft.banner.circle.blue": "Cearcall gorm",
  "block.minecraft.banner.circle.brown": "Cearcall donn",
  "block.minecraft.banner.circle.cyan": "Cearcall saidhean",
  "block.minecraft.banner.circle.gray": "Cearcall liath",
  "block.minecraft.banner.circle.green": "Cearcall uaine",
  "block.minecraft.banner.circle.light_blue": "Cearcall soilleir-ghorm",
  "block.minecraft.banner.circle.light_gray": "Cearcall soilleir-liath",
  "block.minecraft.banner.circle.lime": "Cearcall dath na liomaid",
  "block.minecraft.banner.circle.magenta": "Cearcall magenta",
  "block.minecraft.banner.circle.orange": "Cearcall orains",
  "block.minecraft.banner.circle.pink": "Cearcall pinc",
  "block.minecraft.banner.circle.purple": "Cearcall purpaidh",
  "block.minecraft.banner.circle.red": "Cearcall dearg",
  "block.minecraft.banner.circle.white": "Cearcall geal",
  "block.minecraft.banner.circle.yellow": "Cearcall buidhe",
  "block.minecraft.banner.creeper.black": "Creeper dubh",
  "block.minecraft.banner.creeper.blue": "Creeper gorm",
  "block.minecraft.banner.creeper.brown": "Creeper donn",
  "block.minecraft.banner.creeper.cyan": "Creeper saidhean",
  "block.minecraft.banner.creeper.gray": "Creeper liath",
  "block.minecraft.banner.creeper.green": "Creeper uaine",
  "block.minecraft.banner.creeper.light_blue": "Creeper soilleir-ghorm",
  "block.minecraft.banner.creeper.light_gray": "Creeper soilleir-liath",
  "block.minecraft.banner.creeper.lime": "Creeper dath na liomaide",
  "block.minecraft.banner.creeper.magenta": "Creeper magenta",
  "block.minecraft.banner.creeper.orange": "Creeper orains",
  "block.minecraft.banner.creeper.pink": "Creeper pinc",
  "block.minecraft.banner.creeper.purple": "Creeper purpaidh",
  "block.minecraft.banner.creeper.red": "Creeper dearg",
  "block.minecraft.banner.creeper.white": "Creeper geal",
  "block.minecraft.banner.creeper.yellow": "Creeper buidhe",
  "block.minecraft.banner.cross.black": "Crann dubh",
  "block.minecraft.banner.cross.blue": "Crann gorm",
  "block.minecraft.banner.cross.brown": "Crann donn",
  "block.minecraft.banner.cross.cyan": "Crann saidhean",
  "block.minecraft.banner.cross.gray": "Crann glas",
  "block.minecraft.banner.cross.green": "Crann uaine",
  "block.minecraft.banner.cross.light_blue": "Crann bàn-ghorm",
  "block.minecraft.banner.cross.light_gray": "Crann liath",
  "block.minecraft.banner.cross.lime": "Crann bàn-uaine",
  "block.minecraft.banner.cross.magenta": "Crann maidèanta",
  "block.minecraft.banner.cross.orange": "Crann orains",
  "block.minecraft.banner.cross.pink": "Crann bàn-dearg",
  "block.minecraft.banner.cross.purple": "Crann purpaidh",
  "block.minecraft.banner.cross.red": "Crann dearg",
  "block.minecraft.banner.cross.white": "Crann geal",
  "block.minecraft.banner.cross.yellow": "Crann buidhe",
  "block.minecraft.banner.curly_border.black": "Iomallan eagach dubha",
  "block.minecraft.banner.curly_border.blue": "Iomallan eagach gorma",
  "block.minecraft.banner.curly_border.brown": "Iomallan eagach donna",
  "block.minecraft.banner.curly_border.cyan": "Iomallan eagach saidhean",
  "block.minecraft.banner.curly_border.gray": "Iomallan eagach liatha",
  "block.minecraft.banner.curly_border.green": "Iomallan eagach uaine",
  "block.minecraft.banner.curly_border.light_blue": "Iomallan eagach soilleir-ghorma",
  "block.minecraft.banner.curly_border.light_gray": "Iomallan eagach soilleir-liatha",
  "block.minecraft.banner.curly_border.lime": "Iomallan eagach dath na liomaid",
  "block.minecraft.banner.curly_border.magenta": "Iomallan eagach magenta",
  "block.minecraft.banner.curly_border.orange": "Iomallan eagach orains",
  "block.minecraft.banner.curly_border.pink": "Iomallan eagach pince",
  "block.minecraft.banner.curly_border.purple": "Iomallan eagach purpaidh",
  "block.minecraft.banner.curly_border.red": "Iomallan eagach dearga",
  "block.minecraft.banner.curly_border.white": "Iomallan eagach geala",
  "block.minecraft.banner.curly_border.yellow": "Iomallan eagach buidhe",
  "block.minecraft.banner.diagonal_left.black": "Roinneadh toisgeal dubh",
  "block.minecraft.banner.diagonal_left.blue": "Roinneadh toisgeal gorm",
  "block.minecraft.banner.diagonal_left.brown": "Roinneadh toisgeal donn",
  "block.minecraft.banner.diagonal_left.cyan": "Roinneadh toisgeal saidhean",
  "block.minecraft.banner.diagonal_left.gray": "Roinneadh toisgeal glas",
  "block.minecraft.banner.diagonal_left.green": "Roinneadh toisgeal uaine",
  "block.minecraft.banner.diagonal_left.light_blue": "Roinneadh toisgeal bàn-ghorm",
  "block.minecraft.banner.diagonal_left.light_gray": "Roinneadh toisgeal liath",
  "block.minecraft.banner.diagonal_left.lime": "Roinneadh toisgeal bàn-uaine",
  "block.minecraft.banner.diagonal_left.magenta": "Roinneadh toisgeal maidèanta",
  "block.minecraft.banner.diagonal_left.orange": "Roinneadh toisgeal orains",
  "block.minecraft.banner.diagonal_left.pink": "Roinneadh toisgeal bàn-dearg",
  "block.minecraft.banner.diagonal_left.purple": "Roinneadh toisgeal purpaidh",
  "block.minecraft.banner.diagonal_left.red": "Roinneadh toisgeal dearg",
  "block.minecraft.banner.diagonal_left.white": "Roinneadh toisgeal geal",
  "block.minecraft.banner.diagonal_left.yellow": "Roinneadh toisgeal buidhe",
  "block.minecraft.banner.diagonal_right.black": "Roinneadh dubh",
  "block.minecraft.banner.diagonal_right.blue": "Roinneadh gorm",
  "block.minecraft.banner.diagonal_right.brown": "Roinneadh donn",
  "block.minecraft.banner.diagonal_right.cyan": "Roinneadh saidhean",
  "block.minecraft.banner.diagonal_right.gray": "Roinneadh glas",
  "block.minecraft.banner.diagonal_right.green": "Roinneadh uaine",
  "block.minecraft.banner.diagonal_right.light_blue": "Roinneadh bàn-ghorm",
  "block.minecraft.banner.diagonal_right.light_gray": "Roinneadh liath",
  "block.minecraft.banner.diagonal_right.lime": "Roinneadh bàn-uaine",
  "block.minecraft.banner.diagonal_right.magenta": "Roinneadh maidèanta",
  "block.minecraft.banner.diagonal_right.orange": "Roinneadh orains",
  "block.minecraft.banner.diagonal_right.pink": "Roinneadh bàn-dearg",
  "block.minecraft.banner.diagonal_right.purple": "Roinneadh purpaidh",
  "block.minecraft.banner.diagonal_right.red": "Roinneadh dearg",
  "block.minecraft.banner.diagonal_right.white": "Roinneadh geal",
  "block.minecraft.banner.diagonal_right.yellow": "Roinneadh buidhe",
  "block.minecraft.banner.diagonal_up_left.black": "Roinneadh ais-thionndaichte dubh",
  "block.minecraft.banner.diagonal_up_left.blue": "Roinneadh inghearach gorm taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.brown": "Roinneadh inghearach donn taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.cyan": "Roinneadh inghearach saidhean taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.gray": "Roinneadh inghearach liath taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.green": "Roinneadh inghearach uaine taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Roinneadh inghearach soilleir-ghorm taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Roinneadh inghearach soilleir-liath taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.lime": "Roinneadh inghearach dath na liomaid taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.magenta": "Roinneadh inghearach magenta taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.orange": "Roinneadh inghearach orains taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.pink": "Roinneadh inghearach pinc taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.purple": "Roinneadh inghearach purpaidh taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.red": "Roinneadh inghearach dearg taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.white": "Roinneadh inghearach geal taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_left.yellow": "Roinneadh inghearach buidhe taobh clì aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.black": "Roinneadh inghearach dubh taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.blue": "Roinneadh inghearach gorm taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.brown": "Roinneadh inghearach donn taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.cyan": "Roinneadh inghearach saidhean taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.gray": "Roinneadh inghearach liath taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.green": "Roinneadh inghearach uaine taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Roinneadh inghearach soilleir-ghorm taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Roinneadh inghearach soilleir-liath taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.lime": "Roinneadh inghearach dath na liomaid taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.magenta": "Roinneadh inghearach magenta taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.orange": "Roinneadh inghearach orains taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.pink": "Roinneadh inghearach pinc taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.purple": "Roinneadh inghearach purpaidh taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.red": "Roinneadh inghearach dearg taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.white": "Roinneadh inghearach geal taobh deas aig a' bhonn",
  "block.minecraft.banner.diagonal_up_right.yellow": "Roinneadh inghearach buidhe taobh deas aig a' bhonn",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Flùr dubh",
  "block.minecraft.banner.flower.blue": "Flùr gorm",
  "block.minecraft.banner.flower.brown": "Flùr donn",
  "block.minecraft.banner.flower.cyan": "Flùr saidhean",
  "block.minecraft.banner.flower.gray": "Flùr liath",
  "block.minecraft.banner.flower.green": "Flùr uaine",
  "block.minecraft.banner.flower.light_blue": "Flùr soilleir-ghorm",
  "block.minecraft.banner.flower.light_gray": "Flùr soilleir-liath",
  "block.minecraft.banner.flower.lime": "Flùr dath na liomaide",
  "block.minecraft.banner.flower.magenta": "Flùr magenta",
  "block.minecraft.banner.flower.orange": "Flùr orains",
  "block.minecraft.banner.flower.pink": "Flùr pinc",
  "block.minecraft.banner.flower.purple": "Flùr purpaidh",
  "block.minecraft.banner.flower.red": "Flùr dearg",
  "block.minecraft.banner.flower.white": "Flùr geal",
  "block.minecraft.banner.flower.yellow": "Flùr buidhe",
  "block.minecraft.banner.globe.black": "Cruinne dubh",
  "block.minecraft.banner.globe.blue": "Cruinne gorm",
  "block.minecraft.banner.globe.brown": "Cruinne donn",
  "block.minecraft.banner.globe.cyan": "Cruinne cian",
  "block.minecraft.banner.globe.gray": "Cruinne liath",
  "block.minecraft.banner.globe.green": "Cruinne uaine",
  "block.minecraft.banner.globe.light_blue": "Cruinne gorm aotrom",
  "block.minecraft.banner.globe.light_gray": "Cruinne liath aotrom",
  "block.minecraft.banner.globe.lime": "Cruinne aol",
  "block.minecraft.banner.globe.magenta": "Cruinne magenta",
  "block.minecraft.banner.globe.orange": "Cruinne orains",
  "block.minecraft.banner.globe.pink": "Cruinne pinc",
  "block.minecraft.banner.globe.purple": "Cruinne purpaidh",
  "block.minecraft.banner.globe.red": "Cruinne ruadh",
  "block.minecraft.banner.globe.white": "Cruinne geal",
  "block.minecraft.banner.globe.yellow": "Cruinne buidhe",
  "block.minecraft.banner.gradient.black": "Caisead dubh on bharr",
  "block.minecraft.banner.gradient.blue": "Caisead gorm on bharr",
  "block.minecraft.banner.gradient.brown": "Caisead donn on bharr",
  "block.minecraft.banner.gradient.cyan": "Caisead saidhean on bharr",
  "block.minecraft.banner.gradient.gray": "Caisead liath on bharr",
  "block.minecraft.banner.gradient.green": "Caisead uaine on bharr",
  "block.minecraft.banner.gradient.light_blue": "Caisead soilleir-ghorm on bharr",
  "block.minecraft.banner.gradient.light_gray": "Caisead soilleir-liath on bharr",
  "block.minecraft.banner.gradient.lime": "Caisead dath na liomaid on bharr",
  "block.minecraft.banner.gradient.magenta": "Caisead magenta on bharr",
  "block.minecraft.banner.gradient.orange": "Caisead orains on bharr",
  "block.minecraft.banner.gradient.pink": "Caisead pinc on bharr",
  "block.minecraft.banner.gradient.purple": "Caisead purpaidh on bharr",
  "block.minecraft.banner.gradient.red": "Caisead dearg on bharr",
  "block.minecraft.banner.gradient.white": "Caisead geal on bharr",
  "block.minecraft.banner.gradient.yellow": "Caisead buidhe on bharr",
  "block.minecraft.banner.gradient_up.black": "Caisead dubh on bhonn",
  "block.minecraft.banner.gradient_up.blue": "Caisead gorm on bhonn",
  "block.minecraft.banner.gradient_up.brown": "Caisead donn on bhonn",
  "block.minecraft.banner.gradient_up.cyan": "Caisead saidhean on bhonn",
  "block.minecraft.banner.gradient_up.gray": "Caisead liath on bhonn",
  "block.minecraft.banner.gradient_up.green": "Caisead uaine on bhonn",
  "block.minecraft.banner.gradient_up.light_blue": "Caisead soilleir-ghorm on bhonn",
  "block.minecraft.banner.gradient_up.light_gray": "Caisead soilleir-liath on bhonn",
  "block.minecraft.banner.gradient_up.lime": "Caisead dath na liomaid on bhonn",
  "block.minecraft.banner.gradient_up.magenta": "Caisead magenta on bhonn",
  "block.minecraft.banner.gradient_up.orange": "Caisead orains on bhonn",
  "block.minecraft.banner.gradient_up.pink": "Caisead pinc on bhonn",
  "block.minecraft.banner.gradient_up.purple": "Caisead purpaidh on bhonn",
  "block.minecraft.banner.gradient_up.red": "Caisead dearg on bhonn",
  "block.minecraft.banner.gradient_up.white": "Caisead geal on bhonn",
  "block.minecraft.banner.gradient_up.yellow": "Caisead buidhe on bhonn",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Roinneadh dubh aig a' bharr",
  "block.minecraft.banner.half_horizontal.blue": "Roinneadh gorm aig a' bharr",
  "block.minecraft.banner.half_horizontal.brown": "Roinneadh donn aig a' bharr",
  "block.minecraft.banner.half_horizontal.cyan": "Roinneadh saidhean aig a' bharr",
  "block.minecraft.banner.half_horizontal.gray": "Roinneadh liath aig a' bharr",
  "block.minecraft.banner.half_horizontal.green": "Roinneadh uaine aig a' bharr",
  "block.minecraft.banner.half_horizontal.light_blue": "Roinneadh soilleir-ghorm aig a' bharr",
  "block.minecraft.banner.half_horizontal.light_gray": "Roinneadh soilleir-liath aig a' bharr",
  "block.minecraft.banner.half_horizontal.lime": "Roinneadh dath na liomaid aig a' bharr",
  "block.minecraft.banner.half_horizontal.magenta": "Roinneadh magenta aig a' bharr",
  "block.minecraft.banner.half_horizontal.orange": "Roinneadh orains aig a' bharr",
  "block.minecraft.banner.half_horizontal.pink": "Roinneadh pinc aig a' bharr",
  "block.minecraft.banner.half_horizontal.purple": "Roinneadh purpaidh aig a' bharr",
  "block.minecraft.banner.half_horizontal.red": "Roinneadh dearg aig a' bharr",
  "block.minecraft.banner.half_horizontal.white": "Roinneadh geal aig a' bharr",
  "block.minecraft.banner.half_horizontal.yellow": "Roinneadh buidhe aig a' bharr",
  "block.minecraft.banner.half_horizontal_bottom.black": "Roinneadh dubh aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Roinneadh gorm aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Roinneadh donn aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Roinneadh saidhean aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Roinneadh liath aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.green": "Roinneadh uaine aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Roinneadh soilleir-ghorm aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Roinneadh soilleir-liath aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Roinneadh dath na liomaid aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Roinneadh magenta aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Roinneadh orains aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Roinneadh pinc aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Roinneadh purpaidh aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.red": "Roinneadh dearg aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.white": "Roinneadh geal aig a' bhonn",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Roinneadh buidhe aig a' bhonn",
  "block.minecraft.banner.half_vertical.black": "Roinneadh inghearach dubh air an taobh chlì",
  "block.minecraft.banner.half_vertical.blue": "Roinneadh inghearach gorm air an taobh chlì",
  "block.minecraft.banner.half_vertical.brown": "Roinneadh inghearach donn air an taobh chlì",
  "block.minecraft.banner.half_vertical.cyan": "Roinneadh inghearach saidhean air an taobh chlì",
  "block.minecraft.banner.half_vertical.gray": "Roinneadh inghearach liath air an taobh chlì",
  "block.minecraft.banner.half_vertical.green": "Roinneadh inghearach uaine air an taobh chlì",
  "block.minecraft.banner.half_vertical.light_blue": "Roinneadh inghearach soilleir-ghorm air an taobh chlì",
  "block.minecraft.banner.half_vertical.light_gray": "Roinneadh inghearach soilleir-liath air an taobh chlì",
  "block.minecraft.banner.half_vertical.lime": "Roinneadh inghearach dath na liomaid air an taobh chlì",
  "block.minecraft.banner.half_vertical.magenta": "Roinneadh inghearach magenta air an taobh chlì",
  "block.minecraft.banner.half_vertical.orange": "Roinneadh inghearach orains air an taobh chlì",
  "block.minecraft.banner.half_vertical.pink": "Roinneadh inghearach pinc air an taobh chlì",
  "block.minecraft.banner.half_vertical.purple": "Roinneadh inghearach purpaidh air an taobh chlì",
  "block.minecraft.banner.half_vertical.red": "Roinneadh inghearach dearg air an taobh chlì",
  "block.minecraft.banner.half_vertical.white": "Roinneadh inghearach geal air an taobh chlì",
  "block.minecraft.banner.half_vertical.yellow": "Roinneadh inghearach buidhe air an taobh chlì",
  "block.minecraft.banner.half_vertical_right.black": "Roinneadh inghearach dubh air an taobh deas",
  "block.minecraft.banner.half_vertical_right.blue": "Roinneadh inghearach gorm air an taobh deas",
  "block.minecraft.banner.half_vertical_right.brown": "Roinneadh inghearach donn air an taobh deas",
  "block.minecraft.banner.half_vertical_right.cyan": "Roinneadh inghearach saidhean air an taobh deas",
  "block.minecraft.banner.half_vertical_right.gray": "Roinneadh inghearach liath air an taobh deas",
  "block.minecraft.banner.half_vertical_right.green": "Roinneadh inghearach uaine air an taobh deas",
  "block.minecraft.banner.half_vertical_right.light_blue": "Roinneadh inghearach soilleir-ghorm air an taobh deas",
  "block.minecraft.banner.half_vertical_right.light_gray": "Roinneadh inghearach soilleir-liath air an taobh deas",
  "block.minecraft.banner.half_vertical_right.lime": "Roinneadh inghearach dath na liomaid air an taobh deas",
  "block.minecraft.banner.half_vertical_right.magenta": "Roinneadh inghearach magenta air an taobh deas",
  "block.minecraft.banner.half_vertical_right.orange": "Roinneadh inghearach orains air an taobh deas",
  "block.minecraft.banner.half_vertical_right.pink": "Roinneadh inghearach pinc air an taobh deas",
  "block.minecraft.banner.half_vertical_right.purple": "Roinneadh inghearach purpaidh air an taobh deas",
  "block.minecraft.banner.half_vertical_right.red": "Roinneadh inghearach dearg air an taobh deas",
  "block.minecraft.banner.half_vertical_right.white": "Roinneadh inghearach geal air an taobh deas",
  "block.minecraft.banner.half_vertical_right.yellow": "Roinneadh inghearach buidhe air an taobh deas",
  "block.minecraft.banner.mojang.black": "Suaicheantas dubh",
  "block.minecraft.banner.mojang.blue": "Suaicheantas gorm",
  "block.minecraft.banner.mojang.brown": "Suaicheantas donn",
  "block.minecraft.banner.mojang.cyan": "Suaicheantas saidhean",
  "block.minecraft.banner.mojang.gray": "Suaicheantas liath",
  "block.minecraft.banner.mojang.green": "Suaicheantas uaine",
  "block.minecraft.banner.mojang.light_blue": "Suaicheantas soilleir-ghorm",
  "block.minecraft.banner.mojang.light_gray": "Suaicheantas soilleir-liath",
  "block.minecraft.banner.mojang.lime": "Suaicheantas dath na liomaid",
  "block.minecraft.banner.mojang.magenta": "Suaicheantas magenta",
  "block.minecraft.banner.mojang.orange": "Suaicheantas orains",
  "block.minecraft.banner.mojang.pink": "Suaicheantas pinc",
  "block.minecraft.banner.mojang.purple": "Suaicheantas purpaidh",
  "block.minecraft.banner.mojang.red": "Suaicheantas dearg",
  "block.minecraft.banner.mojang.white": "Suaicheantas geal",
  "block.minecraft.banner.mojang.yellow": "Suaicheantas buidhe",
  "block.minecraft.banner.piglin.black": "Black Snout",
  "block.minecraft.banner.piglin.blue": "Blue Snout",
  "block.minecraft.banner.piglin.brown": "Brown Snout",
  "block.minecraft.banner.piglin.cyan": ": Saidhean Snout",
  "block.minecraft.banner.piglin.gray": "Gray Snout",
  "block.minecraft.banner.piglin.green": "Green Snout",
  "block.minecraft.banner.piglin.light_blue": "Light Blue Snout",
  "block.minecraft.banner.piglin.light_gray": "Light Gray Snout",
  "block.minecraft.banner.piglin.lime": "Lime Snout",
  "block.minecraft.banner.piglin.magenta": "Maidèanta Ann Snout",
  "block.minecraft.banner.piglin.orange": "Orange Snout",
  "block.minecraft.banner.piglin.pink": "Pink Snout",
  "block.minecraft.banner.piglin.purple": "Purpaidh Snout",
  "block.minecraft.banner.piglin.red": "Red Snout",
  "block.minecraft.banner.piglin.white": "White Snout",
  "block.minecraft.banner.piglin.yellow": "Yellow Snout",
  "block.minecraft.banner.rhombus.black": "Rombas dhubh",
  "block.minecraft.banner.rhombus.blue": "Rombas ghorm",
  "block.minecraft.banner.rhombus.brown": "Rombas dhonn",
  "block.minecraft.banner.rhombus.cyan": "Rombas shaidhean",
  "block.minecraft.banner.rhombus.gray": "Rombas liath",
  "block.minecraft.banner.rhombus.green": "Rombas uaine",
  "block.minecraft.banner.rhombus.light_blue": "Rombas shoilleir-ghorm",
  "block.minecraft.banner.rhombus.light_gray": "Rombas shoilleir-liath",
  "block.minecraft.banner.rhombus.lime": "Rombas dath na liomaid",
  "block.minecraft.banner.rhombus.magenta": "Rombas mhagenta",
  "block.minecraft.banner.rhombus.orange": "Rombas orains",
  "block.minecraft.banner.rhombus.pink": "Rombas phinc",
  "block.minecraft.banner.rhombus.purple": "Rombas phurpaidh",
  "block.minecraft.banner.rhombus.red": "Rombas dhearg",
  "block.minecraft.banner.rhombus.white": "Rombas gheal",
  "block.minecraft.banner.rhombus.yellow": "Rombas bhuidhe",
  "block.minecraft.banner.skull.black": "Claigeann dubh",
  "block.minecraft.banner.skull.blue": "Claigeann gorm",
  "block.minecraft.banner.skull.brown": "Claigeann donn",
  "block.minecraft.banner.skull.cyan": "Claigeann saidhean",
  "block.minecraft.banner.skull.gray": "Claigeann liath",
  "block.minecraft.banner.skull.green": "Claigeann uaine",
  "block.minecraft.banner.skull.light_blue": "Claigeann soilleir-ghorm",
  "block.minecraft.banner.skull.light_gray": "Claigeann soilleir-liath",
  "block.minecraft.banner.skull.lime": "Claigeann dath na liomaide",
  "block.minecraft.banner.skull.magenta": "Claigeann magenta",
  "block.minecraft.banner.skull.orange": "Claigeann orains",
  "block.minecraft.banner.skull.pink": "Claigeann pinc",
  "block.minecraft.banner.skull.purple": "Claigeann purpaidh",
  "block.minecraft.banner.skull.red": "Claigeann dearg",
  "block.minecraft.banner.skull.white": "Claigeann geal",
  "block.minecraft.banner.skull.yellow": "Claigeann buidhe",
  "block.minecraft.banner.small_stripes.black": "Stiallagan dubha",
  "block.minecraft.banner.small_stripes.blue": "Stiallagan gorma",
  "block.minecraft.banner.small_stripes.brown": "Stiallagan donna",
  "block.minecraft.banner.small_stripes.cyan": "Stiallagan saidhean",
  "block.minecraft.banner.small_stripes.gray": "Stiallagan glasa",
  "block.minecraft.banner.small_stripes.green": "Stiallagan uaine",
  "block.minecraft.banner.small_stripes.light_blue": "Stiallagan bàn-ghorma",
  "block.minecraft.banner.small_stripes.light_gray": "Stiallagan liatha",
  "block.minecraft.banner.small_stripes.lime": "Stiallagan bàn-uaine",
  "block.minecraft.banner.small_stripes.magenta": "Stiallagan maidèanta",
  "block.minecraft.banner.small_stripes.orange": "Stiallagan orains",
  "block.minecraft.banner.small_stripes.pink": "Stiallagan bàn-dearg",
  "block.minecraft.banner.small_stripes.purple": "Stiallagan purpaidh",
  "block.minecraft.banner.small_stripes.red": "Stiallagan dearga",
  "block.minecraft.banner.small_stripes.white": "Stiallagan geala",
  "block.minecraft.banner.small_stripes.yellow": "Stiallagan buidhe",
  "block.minecraft.banner.square_bottom_left.black": "Ceithir-cheàrnag dheiseal dhubh aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.blue": "Ceithir-cheàrnag dheiseal ghorm aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.brown": "Ceithir-cheàrnag dheiseal dhonn aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.cyan": "Ceithir-cheàrnag dheiseal shaidhean aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.gray": "Ceithir-cheàrnag dheiseal ghlas aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.green": "Ceithir-cheàrnag dheiseal uaine aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ceithir-cheàrnag dheiseal bhàn-ghorm aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ceithir-cheàrnag dheiseal liath aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.lime": "Ceithir-cheàrnag dheiseal bhàn-uaine aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.magenta": "Ceithir-cheàrnag dheiseal mhaidèanta aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.orange": "Ceithir-cheàrnag dheiseal orains aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.pink": "Ceithir-cheàrnag dheiseal bhàn-dearg aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.purple": "Ceithir-cheàrnag dheiseal phurpaidh aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.red": "Ceithir-cheàrnag dheiseal dhearg aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.white": "Ceithir-cheàrnag dheiseal gheal aig a' bhonn",
  "block.minecraft.banner.square_bottom_left.yellow": "Ceithir-cheàrnag dheiseal bhuidhe aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.black": "Ceithir-cheàrnag thoisgeal dhubh aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.blue": "Ceithir-cheàrnag thoisgeal ghorm aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.brown": "Ceithir-cheàrnag thoisgeal dhonn aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.cyan": "Ceithir-cheàrnag thoisgeal shaidhean aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.gray": "Ceithir-cheàrnag thoisgeal ghlas aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.green": "Ceithir-cheàrnag thoisgeal uaine aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ceithir-cheàrnag thoisgeal bhàn-ghorm aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ceithir-cheàrnag thoisgeal liath aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.lime": "Ceithir-cheàrnag thoisgeal bhàn-uaine aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.magenta": "Ceithir-cheàrnag thoisgeal mhaidèanta aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.orange": "Ceithir-cheàrnag thoisgeal orains aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.pink": "Ceithir-cheàrnag thoisgeal bhàn-dearg aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.purple": "Ceithir-cheàrnag thoisgeal phurpaidh aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.red": "Ceithir-cheàrnag thoisgeal dhearg aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.white": "Ceithir-cheàrnag thoisgeal gheal aig a' bhonn",
  "block.minecraft.banner.square_bottom_right.yellow": "Ceithir-cheàrnag thoisgeal bhuidhe aig a' bhonn",
  "block.minecraft.banner.square_top_left.black": "Ceithir-cheàrnag dheiseal dhubh aig a' bhàrr",
  "block.minecraft.banner.square_top_left.blue": "Ceithir-cheàrnag dheiseal ghorm aig a' bhàrr",
  "block.minecraft.banner.square_top_left.brown": "Ceithir-cheàrnag dheiseal dhonn aig a' bhàrr",
  "block.minecraft.banner.square_top_left.cyan": "Ceithir-cheàrnag dheiseal shaidhean aig a' bhàrr",
  "block.minecraft.banner.square_top_left.gray": "Ceithir-cheàrnag dheiseal ghlas aig a' bhàrr",
  "block.minecraft.banner.square_top_left.green": "Ceithir-cheàrnag dheiseal uaine aig a' bhàrr",
  "block.minecraft.banner.square_top_left.light_blue": "Ceithir-cheàrnag dheiseal bhàn-ghorm aig a' bhàrr",
  "block.minecraft.banner.square_top_left.light_gray": "Ceithir-cheàrnag dheiseal liath aig a' bhàrr",
  "block.minecraft.banner.square_top_left.lime": "Ceithir-cheàrnag dheiseal bhàn-uaine aig a' bhàrr",
  "block.minecraft.banner.square_top_left.magenta": "Ceithir-cheàrnag dheiseal mhaidèanta aig a' bhàrr",
  "block.minecraft.banner.square_top_left.orange": "Ceithir-cheàrnag dheiseal orains aig a' bhàrr",
  "block.minecraft.banner.square_top_left.pink": "Ceithir-cheàrnag dheiseal bhàn-dearg aig a' bhàrr",
  "block.minecraft.banner.square_top_left.purple": "Ceithir-cheàrnag dheiseal phurpaidh aig a' bhàrr",
  "block.minecraft.banner.square_top_left.red": "Ceithir-cheàrnag dheiseal dhearg aig a' bhàrr",
  "block.minecraft.banner.square_top_left.white": "Ceithir-cheàrnag dheiseal gheal aig a' bhàrr",
  "block.minecraft.banner.square_top_left.yellow": "Ceithir-cheàrnag dheiseal bhuidhe aig a' bhàrr",
  "block.minecraft.banner.square_top_right.black": "Ceithir-cheàrnag thoisgeal dhubh aig a' bhàrr",
  "block.minecraft.banner.square_top_right.blue": "Ceithir-cheàrnag thoisgeal ghorm aig a' bhàrr",
  "block.minecraft.banner.square_top_right.brown": "Ceithir-cheàrnag thoisgeal dhonn aig a' bhàrr",
  "block.minecraft.banner.square_top_right.cyan": "Ceithir-cheàrnag thoisgeal shaidhean aig a' bhàrr",
  "block.minecraft.banner.square_top_right.gray": "Ceithir-cheàrnag thoisgeal ghlas aig a' bhàrr",
  "block.minecraft.banner.square_top_right.green": "Ceithir-cheàrnag thoisgeal uaine aig a' bhàrr",
  "block.minecraft.banner.square_top_right.light_blue": "Ceithir-cheàrnag thoisgeal bhàn-ghorm aig a' bhàrr",
  "block.minecraft.banner.square_top_right.light_gray": "Ceithir-cheàrnag thoisgeal liath aig a' bhàrr",
  "block.minecraft.banner.square_top_right.lime": "Ceithir-cheàrnag thoisgeal bhàn-uaine aig a' bhàrr",
  "block.minecraft.banner.square_top_right.magenta": "Ceithir-cheàrnag thoisgeal mhaidèanta aig a' bhàrr",
  "block.minecraft.banner.square_top_right.orange": "Ceithir-cheàrnag thoisgeal orains aig a' bhàrr",
  "block.minecraft.banner.square_top_right.pink": "Ceithir-cheàrnag thoisgeal bhàn-dearg aig a' bhàrr",
  "block.minecraft.banner.square_top_right.purple": "Ceithir-cheàrnag thoisgeal phurpaidh aig a' bhàrr",
  "block.minecraft.banner.square_top_right.red": "Ceithir-cheàrnag thoisgeal dhearg aig a' bhàrr",
  "block.minecraft.banner.square_top_right.white": "Ceithir-cheàrnag thoisgeal gheal aig a' bhàrr",
  "block.minecraft.banner.square_top_right.yellow": "Ceithir-cheàrnag thoisgeal bhuidhe aig a' bhàrr",
  "block.minecraft.banner.straight_cross.black": "Crois dhubh",
  "block.minecraft.banner.straight_cross.blue": "Crois ghorm",
  "block.minecraft.banner.straight_cross.brown": "Crois dhonn",
  "block.minecraft.banner.straight_cross.cyan": "Crois shaidhean",
  "block.minecraft.banner.straight_cross.gray": "Crois liath",
  "block.minecraft.banner.straight_cross.green": "Crois uaine",
  "block.minecraft.banner.straight_cross.light_blue": "Crois shoilleir-ghorm",
  "block.minecraft.banner.straight_cross.light_gray": "Crois shoilleir-liath",
  "block.minecraft.banner.straight_cross.lime": "Crois dath na liomaid",
  "block.minecraft.banner.straight_cross.magenta": "Crois mhagenta",
  "block.minecraft.banner.straight_cross.orange": "Crois orains",
  "block.minecraft.banner.straight_cross.pink": "Crois phinc",
  "block.minecraft.banner.straight_cross.purple": "Crois phurpaidh",
  "block.minecraft.banner.straight_cross.red": "Crois dhearg",
  "block.minecraft.banner.straight_cross.white": "Crois gheal",
  "block.minecraft.banner.straight_cross.yellow": "Crois bhuidhe",
  "block.minecraft.banner.stripe_bottom.black": "Bonn dubh",
  "block.minecraft.banner.stripe_bottom.blue": "Bonn gorm",
  "block.minecraft.banner.stripe_bottom.brown": "Bonn donn",
  "block.minecraft.banner.stripe_bottom.cyan": "Bonn saidhean",
  "block.minecraft.banner.stripe_bottom.gray": "Bonn glas",
  "block.minecraft.banner.stripe_bottom.green": "Bonn uaine",
  "block.minecraft.banner.stripe_bottom.light_blue": "Bonn bàn-ghorm",
  "block.minecraft.banner.stripe_bottom.light_gray": "Bonn liath",
  "block.minecraft.banner.stripe_bottom.lime": "Bonn bàn-uaine",
  "block.minecraft.banner.stripe_bottom.magenta": "Bonn maidèanta",
  "block.minecraft.banner.stripe_bottom.orange": "Bonn orains",
  "block.minecraft.banner.stripe_bottom.pink": "Bonn bàn-dearg",
  "block.minecraft.banner.stripe_bottom.purple": "Bonn purpaidh",
  "block.minecraft.banner.stripe_bottom.red": "Bonn dearg",
  "block.minecraft.banner.stripe_bottom.white": "Bonn geal",
  "block.minecraft.banner.stripe_bottom.yellow": "Bonn buidhe",
  "block.minecraft.banner.stripe_center.black": "Stiall dhubh",
  "block.minecraft.banner.stripe_center.blue": "Stiall ghorm",
  "block.minecraft.banner.stripe_center.brown": "Stiall dhonn",
  "block.minecraft.banner.stripe_center.cyan": "Stiall shaidhean",
  "block.minecraft.banner.stripe_center.gray": "Stiall ghlas",
  "block.minecraft.banner.stripe_center.green": "Stiall uaine",
  "block.minecraft.banner.stripe_center.light_blue": "Stiall bhàn-ghorm",
  "block.minecraft.banner.stripe_center.light_gray": "Stiall liath",
  "block.minecraft.banner.stripe_center.lime": "Stiall bhàn-uaine",
  "block.minecraft.banner.stripe_center.magenta": "Stiall mhaidèanta",
  "block.minecraft.banner.stripe_center.orange": "Stiall orains",
  "block.minecraft.banner.stripe_center.pink": "Stiall bhàn-dearg",
  "block.minecraft.banner.stripe_center.purple": "Stiall phurpaidh",
  "block.minecraft.banner.stripe_center.red": "Stiall dhearg",
  "block.minecraft.banner.stripe_center.white": "Stiall gheal",
  "block.minecraft.banner.stripe_center.yellow": "Stiall bhuidhe",
  "block.minecraft.banner.stripe_downleft.black": "Trastan toisgeal dubh",
  "block.minecraft.banner.stripe_downleft.blue": "Trastan toisgeal gorm",
  "block.minecraft.banner.stripe_downleft.brown": "Trastan toisgeal donn",
  "block.minecraft.banner.stripe_downleft.cyan": "Trastan toisgeal saidhean",
  "block.minecraft.banner.stripe_downleft.gray": "Trastan toisgeal glas",
  "block.minecraft.banner.stripe_downleft.green": "Trastan toisgeal uaine",
  "block.minecraft.banner.stripe_downleft.light_blue": "Trastan toisgeal bàn-ghorm",
  "block.minecraft.banner.stripe_downleft.light_gray": "Trastan toisgeal liath",
  "block.minecraft.banner.stripe_downleft.lime": "Trastan toisgeal bàn-uaine",
  "block.minecraft.banner.stripe_downleft.magenta": "Trastan toisgeal maidèanta",
  "block.minecraft.banner.stripe_downleft.orange": "Trastan toisgeal orains",
  "block.minecraft.banner.stripe_downleft.pink": "Trastan toisgeal bàn-dearg",
  "block.minecraft.banner.stripe_downleft.purple": "Trastan toisgeal purpaidh",
  "block.minecraft.banner.stripe_downleft.red": "Trastan toisgeal dearg",
  "block.minecraft.banner.stripe_downleft.white": "Trastan toisgeal geal",
  "block.minecraft.banner.stripe_downleft.yellow": "Trastan toisgeal buidhe",
  "block.minecraft.banner.stripe_downright.black": "Trastan dubh",
  "block.minecraft.banner.stripe_downright.blue": "Trastan gorm",
  "block.minecraft.banner.stripe_downright.brown": "Trastan donn",
  "block.minecraft.banner.stripe_downright.cyan": "Trastan saidhean",
  "block.minecraft.banner.stripe_downright.gray": "Trastan glas",
  "block.minecraft.banner.stripe_downright.green": "Trastan uaine",
  "block.minecraft.banner.stripe_downright.light_blue": "Trastan bàn-ghorm",
  "block.minecraft.banner.stripe_downright.light_gray": "Trastan liath",
  "block.minecraft.banner.stripe_downright.lime": "Trastan bàn-uaine",
  "block.minecraft.banner.stripe_downright.magenta": "Trastan maidèanta",
  "block.minecraft.banner.stripe_downright.orange": "Trastan orains",
  "block.minecraft.banner.stripe_downright.pink": "Trastan bàn-dearg",
  "block.minecraft.banner.stripe_downright.purple": "Trastan purpaidh",
  "block.minecraft.banner.stripe_downright.red": "Trastan dearg",
  "block.minecraft.banner.stripe_downright.white": "Trastan geal",
  "block.minecraft.banner.stripe_downright.yellow": "Trastan buidhe",
  "block.minecraft.banner.stripe_left.black": "Stiall dheiseal dhubh",
  "block.minecraft.banner.stripe_left.blue": "Stiall dheiseal ghorm",
  "block.minecraft.banner.stripe_left.brown": "Stiall dheiseal dhonn",
  "block.minecraft.banner.stripe_left.cyan": "Stiall dheiseal shaidhean",
  "block.minecraft.banner.stripe_left.gray": "Stiall dheiseal ghlas",
  "block.minecraft.banner.stripe_left.green": "Stiall dheiseal uaine",
  "block.minecraft.banner.stripe_left.light_blue": "Stiall dheiseal bhàn-ghorm",
  "block.minecraft.banner.stripe_left.light_gray": "Stiall dheiseal liath",
  "block.minecraft.banner.stripe_left.lime": "Stiall dheiseal bhàn-uaine",
  "block.minecraft.banner.stripe_left.magenta": "Stiall dheiseal mhaidèanta",
  "block.minecraft.banner.stripe_left.orange": "Stiall dheiseal orains",
  "block.minecraft.banner.stripe_left.pink": "Stiall dheiseal bhàn-dearg",
  "block.minecraft.banner.stripe_left.purple": "Stiall dheiseal phurpaidh",
  "block.minecraft.banner.stripe_left.red": "Stiall dheiseal dhearg",
  "block.minecraft.banner.stripe_left.white": "Stiall dheiseal gheal",
  "block.minecraft.banner.stripe_left.yellow": "Stiall dheiseal bhuidhe",
  "block.minecraft.banner.stripe_middle.black": "Tarsannan dubh",
  "block.minecraft.banner.stripe_middle.blue": "Tarsannan gorm",
  "block.minecraft.banner.stripe_middle.brown": "Tarsannan donn",
  "block.minecraft.banner.stripe_middle.cyan": "Tarsannan saidhean",
  "block.minecraft.banner.stripe_middle.gray": "Tarsannan glas",
  "block.minecraft.banner.stripe_middle.green": "Tarsannan uaine",
  "block.minecraft.banner.stripe_middle.light_blue": "Tarsannan bàn-ghorm",
  "block.minecraft.banner.stripe_middle.light_gray": "Tarsannan liath",
  "block.minecraft.banner.stripe_middle.lime": "Tarsannan bàn-uaine",
  "block.minecraft.banner.stripe_middle.magenta": "Tarsannan maidèanta",
  "block.minecraft.banner.stripe_middle.orange": "Tarsannan orains",
  "block.minecraft.banner.stripe_middle.pink": "Tarsannan bàn-dearg",
  "block.minecraft.banner.stripe_middle.purple": "Tarsannan purpaidh",
  "block.minecraft.banner.stripe_middle.red": "Tarsannan dearg",
  "block.minecraft.banner.stripe_middle.white": "Tarsannan geal",
  "block.minecraft.banner.stripe_middle.yellow": "Tarsannan buidhe",
  "block.minecraft.banner.stripe_right.black": "Stiall thoisgeal dhubh",
  "block.minecraft.banner.stripe_right.blue": "Stiall thoisgeal ghorm",
  "block.minecraft.banner.stripe_right.brown": "Stiall thoisgeal dhonn",
  "block.minecraft.banner.stripe_right.cyan": "Stiall thoisgeal shaidhean",
  "block.minecraft.banner.stripe_right.gray": "Stiall thoisgeal ghlas",
  "block.minecraft.banner.stripe_right.green": "Stiall thoisgeal uaine",
  "block.minecraft.banner.stripe_right.light_blue": "Stiall thoisgeal bhàn-ghorm",
  "block.minecraft.banner.stripe_right.light_gray": "Stiall thoisgeal liath",
  "block.minecraft.banner.stripe_right.lime": "Stiall thoisgeal bhàn-uaine",
  "block.minecraft.banner.stripe_right.magenta": "Stiall thoisgeal mhaidèanta",
  "block.minecraft.banner.stripe_right.orange": "Stiall thoisgeal orains",
  "block.minecraft.banner.stripe_right.pink": "Stiall thoisgeal bhàn-dearg",
  "block.minecraft.banner.stripe_right.purple": "Stiall thoisgeal phurpaidh",
  "block.minecraft.banner.stripe_right.red": "Stiall thoisgeal dhearg",
  "block.minecraft.banner.stripe_right.white": "Stiall thoisgeal gheal",
  "block.minecraft.banner.stripe_right.yellow": "Stiall thoisgeal bhuidhe",
  "block.minecraft.banner.stripe_top.black": "Bàrr dubh",
  "block.minecraft.banner.stripe_top.blue": "Bàrr gorm",
  "block.minecraft.banner.stripe_top.brown": "Bàrr donn",
  "block.minecraft.banner.stripe_top.cyan": "Bàrr saidhean",
  "block.minecraft.banner.stripe_top.gray": "Bàrr glas",
  "block.minecraft.banner.stripe_top.green": "Bàrr uaine",
  "block.minecraft.banner.stripe_top.light_blue": "Bàrr bàn-ghorm",
  "block.minecraft.banner.stripe_top.light_gray": "Bàrr liath",
  "block.minecraft.banner.stripe_top.lime": "Bàrr bàn-uaine",
  "block.minecraft.banner.stripe_top.magenta": "Bàrr maidèanta",
  "block.minecraft.banner.stripe_top.orange": "Bàrr orains",
  "block.minecraft.banner.stripe_top.pink": "Bàrr bàn-dearg",
  "block.minecraft.banner.stripe_top.purple": "Bàrr purpaidh",
  "block.minecraft.banner.stripe_top.red": "Bàrr dearg",
  "block.minecraft.banner.stripe_top.white": "Bàrr geal",
  "block.minecraft.banner.stripe_top.yellow": "Bàrr buidhe",
  "block.minecraft.banner.triangle_bottom.black": "Saidh dhubh aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.blue": "Saidh ghorm aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.brown": "Saidh dhonn aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.cyan": "Saidh shaidhean aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.gray": "Saidh ghlas aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.green": "Saidh uaine aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.light_blue": "Saidh bhàn-ghorm aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.light_gray": "Saidh liath aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.lime": "Saidh bhàn-uaine aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.magenta": "Saidh mhaidèanta aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.orange": "Saidh orains aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.pink": "Saidh bhàn-dearg aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.purple": "Saidh phurpaidh aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.red": "Saidh dhearg aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.white": "Saidh gheal aig a' bhonn",
  "block.minecraft.banner.triangle_bottom.yellow": "Saidh bhuidhe aig a' bhonn",
  "block.minecraft.banner.triangle_top.black": "Saidh dhubh aig a' bhàrr",
  "block.minecraft.banner.triangle_top.blue": "Saidh ghorm aig a' bhàrr",
  "block.minecraft.banner.triangle_top.brown": "Saidh dhonn aig a' bhàrr",
  "block.minecraft.banner.triangle_top.cyan": "Saidh shaidhean aig a' bhàrr",
  "block.minecraft.banner.triangle_top.gray": "Saidh ghlas aig a' bhàrr",
  "block.minecraft.banner.triangle_top.green": "Saidh uaine aig a' bhàrr",
  "block.minecraft.banner.triangle_top.light_blue": "Saidh bhàn-ghorm aig a' bhàrr",
  "block.minecraft.banner.triangle_top.light_gray": "Saidh liath aig a' bhàrr",
  "block.minecraft.banner.triangle_top.lime": "Saidh bhàn-uaine aig a' bhàrr",
  "block.minecraft.banner.triangle_top.magenta": "Saidh mhaidèanta aig a' bhàrr",
  "block.minecraft.banner.triangle_top.orange": "Saidh orains aig a' bhàrr",
  "block.minecraft.banner.triangle_top.pink": "Saidh bhàn-dearg aig a' bhàrr",
  "block.minecraft.banner.triangle_top.purple": "Saidh phurpaidh aig a' bhàrr",
  "block.minecraft.banner.triangle_top.red": "Saidh dhearg aig a' bhàrr",
  "block.minecraft.banner.triangle_top.white": "Saidh gheal aig a' bhàrr",
  "block.minecraft.banner.triangle_top.yellow": "Saidh bhuidhe aig a' bhàrr",
  "block.minecraft.banner.triangles_bottom.black": "Bonn eagach dubh",
  "block.minecraft.banner.triangles_bottom.blue": "Bonn eagach gorm",
  "block.minecraft.banner.triangles_bottom.brown": "Bonn eagach donn",
  "block.minecraft.banner.triangles_bottom.cyan": "Bonn eagach saidhean",
  "block.minecraft.banner.triangles_bottom.gray": "Bonn eagach glas",
  "block.minecraft.banner.triangles_bottom.green": "Bonn eagach uaine",
  "block.minecraft.banner.triangles_bottom.light_blue": "Bonn eagach bàn-ghorm",
  "block.minecraft.banner.triangles_bottom.light_gray": "Bonn eagach liath",
  "block.minecraft.banner.triangles_bottom.lime": "Bonn eagach bàn-uaine",
  "block.minecraft.banner.triangles_bottom.magenta": "Bonn eagach maidèanta",
  "block.minecraft.banner.triangles_bottom.orange": "Bonn eagach orains",
  "block.minecraft.banner.triangles_bottom.pink": "Bonn eagach bàn-dearg",
  "block.minecraft.banner.triangles_bottom.purple": "Bonn eagach purpaidh",
  "block.minecraft.banner.triangles_bottom.red": "Bonn eagach dearg",
  "block.minecraft.banner.triangles_bottom.white": "Bonn eagach geal",
  "block.minecraft.banner.triangles_bottom.yellow": "Bonn eagach buidhe",
  "block.minecraft.banner.triangles_top.black": "Bàrr eagach dubh",
  "block.minecraft.banner.triangles_top.blue": "Bàrr eagach gorm",
  "block.minecraft.banner.triangles_top.brown": "Bàrr eagach donn",
  "block.minecraft.banner.triangles_top.cyan": "Bàrr eagach saidhean",
  "block.minecraft.banner.triangles_top.gray": "Bàrr eagach glas",
  "block.minecraft.banner.triangles_top.green": "Bàrr eagach uaine",
  "block.minecraft.banner.triangles_top.light_blue": "Bàrr eagach bàn-ghorm",
  "block.minecraft.banner.triangles_top.light_gray": "Bàrr eagach liath",
  "block.minecraft.banner.triangles_top.lime": "Bàrr eagach bàn-uaine",
  "block.minecraft.banner.triangles_top.magenta": "Bàrr eagach maidèanta",
  "block.minecraft.banner.triangles_top.orange": "Bàrr eagach orains",
  "block.minecraft.banner.triangles_top.pink": "Bàrr eagach bàn-dearg",
  "block.minecraft.banner.triangles_top.purple": "Bàrr eagach purpaidh",
  "block.minecraft.banner.triangles_top.red": "Bàrr eagach dearg",
  "block.minecraft.banner.triangles_top.white": "Bàrr eagach geal",
  "block.minecraft.banner.triangles_top.yellow": "Bàrr eagach buidhe",
  "block.minecraft.barrel": "Baraille",
  "block.minecraft.barrier": "Bacadh",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Leus",
  "block.minecraft.beacon.primary": "Prìomh chumhachd",
  "block.minecraft.beacon.secondary": "Cumhachd dhàrnach",
  "block.minecraft.bed.no_sleep": "Chan urrainn dhut cadal ach air an oidhche no rè gaillinn",
  "block.minecraft.bed.not_safe": "Chan fhaigh thu fois an-dràsta; tha uilebheistean am fagas",
  "block.minecraft.bed.obstructed": "Tha an leabaidh seo air a bacadh",
  "block.minecraft.bed.occupied": "Tha cuideigin san leabaidh seo",
  "block.minecraft.bed.too_far_away": "Chan fhaigh thu fois an-dràsta; tha an leabaidh ro fhada air falbh",
  "block.minecraft.bedrock": "Fo-chreag",
  "block.minecraft.bee_nest": "Nead sheillean",
  "block.minecraft.beehive": "Sgeap",
  "block.minecraft.beetroots": "Biatais",
  "block.minecraft.bell": "Clag",
  "block.minecraft.big_dripleaf": "Duille-shnighe mhòr",
  "block.minecraft.big_dripleaf_stem": "Gas duille-shnighe mòire",
  "block.minecraft.birch_button": "Putan beithe",
  "block.minecraft.birch_door": "Doras beithe",
  "block.minecraft.birch_fence": "Feansa beithe",
  "block.minecraft.birch_fence_gate": "Geata feansa beithe",
  "block.minecraft.birch_hanging_sign": "Soidhne-crochadh beithe",
  "block.minecraft.birch_leaves": "Duilleach beithe",
  "block.minecraft.birch_log": "Loga beithe",
  "block.minecraft.birch_planks": "Dèilean beithe",
  "block.minecraft.birch_pressure_plate": "Pleata-brùthaidh beithe",
  "block.minecraft.birch_sapling": "Fiùran beithe",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Soidhne beithe",
  "block.minecraft.birch_slab": "Leac beithe",
  "block.minecraft.birch_stairs": "Staidhre beithe",
  "block.minecraft.birch_trapdoor": "Doras-leigeil beithe",
  "block.minecraft.birch_wall_hanging_sign": "Soidhne-crochadh bhalla beithe",
  "block.minecraft.birch_wall_sign": "Soidhne-bhalla beithe",
  "block.minecraft.birch_wood": "Fiodh beithe",
  "block.minecraft.black_banner": "Bratach dhubh",
  "block.minecraft.black_bed": "Leabaidh dhubh",
  "block.minecraft.black_candle": "Coinneal dhubh",
  "block.minecraft.black_candle_cake": "Cèic le coinneal dhubh",
  "block.minecraft.black_carpet": "Brat-ùrlair dubh",
  "block.minecraft.black_concrete": "Concrait dhubh",
  "block.minecraft.black_concrete_powder": "Mìn-choncrait dhubh",
  "block.minecraft.black_glazed_terracotta": "Terracotta gloinichte dubh",
  "block.minecraft.black_shulker_box": "Bogsa shulker dubh",
  "block.minecraft.black_stained_glass": "Glainne dhathte dhubh",
  "block.minecraft.black_stained_glass_pane": "Leòsan glainne dubh",
  "block.minecraft.black_terracotta": "Terracotta dubh",
  "block.minecraft.black_wool": "Clòimh dhubh",
  "block.minecraft.blackstone": "Dubh-chlach",
  "block.minecraft.blackstone_slab": "Leac dubh-chloiche",
  "block.minecraft.blackstone_stairs": "Staidhre dubh-chloiche",
  "block.minecraft.blackstone_wall": "Balla dubh-chloiche",
  "block.minecraft.blast_furnace": "Fùirneis sèididh",
  "block.minecraft.blue_banner": "Bratach ghorm",
  "block.minecraft.blue_bed": "Leabaidh ghorm",
  "block.minecraft.blue_candle": "Coinneal ghorm",
  "block.minecraft.blue_candle_cake": "Cèic le coinneal ghorm",
  "block.minecraft.blue_carpet": "Brat-ùrlair gorm",
  "block.minecraft.blue_concrete": "Concrait ghorm",
  "block.minecraft.blue_concrete_powder": "Mìn-choncrait ghorm",
  "block.minecraft.blue_glazed_terracotta": "Terracotta gloinichte gorm",
  "block.minecraft.blue_ice": "Deigh ghorm",
  "block.minecraft.blue_orchid": "Magairle ghorm",
  "block.minecraft.blue_shulker_box": "Bogsa shulker gorm",
  "block.minecraft.blue_stained_glass": "Glainne dhathte ghorm",
  "block.minecraft.blue_stained_glass_pane": "Leòsan glainne gorm",
  "block.minecraft.blue_terracotta": "Terracotta gorm",
  "block.minecraft.blue_wool": "Clòimh ghorm",
  "block.minecraft.bone_block": "Bloca cnàmha",
  "block.minecraft.bookshelf": "Sgeilp leabhraichean",
  "block.minecraft.brain_coral": "Coireal-eanchainne",
  "block.minecraft.brain_coral_block": "Bloca coireil-eanchainne",
  "block.minecraft.brain_coral_fan": "Sgàileag coireil-eanchainne",
  "block.minecraft.brain_coral_wall_fan": "Sgàileag-bhalla coireil-eanchainne",
  "block.minecraft.brewing_stand": "Inneal-grùdaireachd",
  "block.minecraft.brick_slab": "Leac bhreigichean",
  "block.minecraft.brick_stairs": "Staidhre bhreigichean",
  "block.minecraft.brick_wall": "Balla bhreigichean",
  "block.minecraft.bricks": "Breigichean",
  "block.minecraft.brown_banner": "Bratach dhonn",
  "block.minecraft.brown_bed": "Leabaidh dhonn",
  "block.minecraft.brown_candle": "Coinneal dhonn",
  "block.minecraft.brown_candle_cake": "Cèic le coinneal dhonn",
  "block.minecraft.brown_carpet": "Brat-ùrlair donn",
  "block.minecraft.brown_concrete": "Concrait dhonn",
  "block.minecraft.brown_concrete_powder": "Mìn-choncrait dhonn",
  "block.minecraft.brown_glazed_terracotta": "Terracotta gloinichte donn",
  "block.minecraft.brown_mushroom": "Balgan-buachair donn",
  "block.minecraft.brown_mushroom_block": "Bloca balgain-bhuachair dhuinn",
  "block.minecraft.brown_shulker_box": "Bogsa shulker donn",
  "block.minecraft.brown_stained_glass": "Glainne dhathte dhonn",
  "block.minecraft.brown_stained_glass_pane": "Leòsan glainne donn",
  "block.minecraft.brown_terracotta": "Terracotta donn",
  "block.minecraft.brown_wool": "Clòimh dhonn",
  "block.minecraft.bubble_column": "Colbh bhuilgean",
  "block.minecraft.bubble_coral": "Coireal-builgein",
  "block.minecraft.bubble_coral_block": "Bloca coireil-bhuilgein",
  "block.minecraft.bubble_coral_fan": "Sgàileag coireil-bhuilgein",
  "block.minecraft.bubble_coral_wall_fan": "Sgàileag-bhalla coireil-bhuilgein",
  "block.minecraft.budding_amethyst": "Amaitist bhagaideach",
  "block.minecraft.bush": "Preas",
  "block.minecraft.cactus": "Cactas",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Cèic",
  "block.minecraft.calcite": "Cailcit",
  "block.minecraft.calibrated_sculk_sensor": "Mothaichear dh'cailbhrich sculk",
  "block.minecraft.campfire": "Teine fosgailte",
  "block.minecraft.candle": "Coinneal",
  "block.minecraft.candle_cake": "Cèic le coinneal",
  "block.minecraft.carrots": "Currain",
  "block.minecraft.cartography_table": "Bòrd cairt-iùlachd",
  "block.minecraft.carved_pumpkin": "Peapag shnaidhte",
  "block.minecraft.cauldron": "Coire",
  "block.minecraft.cave_air": "Adhar uamha",
  "block.minecraft.cave_vines": "Fìonain uamha",
  "block.minecraft.cave_vines_plant": "Lus nam fìonan uamha",
  "block.minecraft.chain": "Slabhraidh",
  "block.minecraft.chain_command_block": "Bloca àitheantan sreatha",
  "block.minecraft.cherry_button": "Putan siris",
  "block.minecraft.cherry_door": "Doras Siris",
  "block.minecraft.cherry_fence": "Fensa Siris",
  "block.minecraft.cherry_fence_gate": "Geata fensa siris",
  "block.minecraft.cherry_hanging_sign": "Soidhne-crochadh siris",
  "block.minecraft.cherry_leaves": "Duilleach siris",
  "block.minecraft.cherry_log": "Loga siris",
  "block.minecraft.cherry_planks": "Dèilean siris",
  "block.minecraft.cherry_pressure_plate": "Pleata-brùthaidh siris",
  "block.minecraft.cherry_sapling": "Fiùran siris",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Soidhne siris",
  "block.minecraft.cherry_slab": "Leac siris",
  "block.minecraft.cherry_stairs": "Staidhre siris",
  "block.minecraft.cherry_trapdoor": "Doras-leigeil siris",
  "block.minecraft.cherry_wall_hanging_sign": "Soidhne-crochadh bhalla siris",
  "block.minecraft.cherry_wall_sign": "Soidhne-bhalla siris",
  "block.minecraft.cherry_wood": "Fiodh siris",
  "block.minecraft.chest": "Ciste",
  "block.minecraft.chipped_anvil": "Innean beàrnach",
  "block.minecraft.chiseled_bookshelf": "Sgeilp leabhraichean gilbichte",
  "block.minecraft.chiseled_copper": "Copar gilbichte",
  "block.minecraft.chiseled_deepslate": "Dubh-sglèat gilbichte",
  "block.minecraft.chiseled_nether_bricks": "Breigichean Nether gilbichte",
  "block.minecraft.chiseled_polished_blackstone": "Dubh-chlach lìomhta ghilbichte",
  "block.minecraft.chiseled_quartz_block": "Bloca eiteige gilbichte",
  "block.minecraft.chiseled_red_sandstone": "Clach-ghainmhich ruadh ghilbichte",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Clach-ghainmhich ghilbichte",
  "block.minecraft.chiseled_stone_bricks": "Breigichean cloiche gilbichte",
  "block.minecraft.chiseled_tuff": "Tuf gilbichte",
  "block.minecraft.chiseled_tuff_bricks": "Breigichean tuf gilbichte",
  "block.minecraft.chorus_flower": "Flùr-sèiste",
  "block.minecraft.chorus_plant": "Lus-sèiste",
  "block.minecraft.clay": "Criadh",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Bloca guail",
  "block.minecraft.coal_ore": "Clach-ghuail",
  "block.minecraft.coarse_dirt": "Ùir gharbh",
  "block.minecraft.cobbled_deepslate": "Dubh-sglèat air a chàsaigeadh",
  "block.minecraft.cobbled_deepslate_slab": "Leac dubh-sglèata air a chàsaigeadh",
  "block.minecraft.cobbled_deepslate_stairs": "Staidhre dubh-sglèata air a chàsaigeadh",
  "block.minecraft.cobbled_deepslate_wall": "Balla dubh-sglèata air a chàsaigeadh",
  "block.minecraft.cobblestone": "Clach-chàsaidh",
  "block.minecraft.cobblestone_slab": "Leac cloiche-càsaidh",
  "block.minecraft.cobblestone_stairs": "Staidhre cloiche-càsaidh",
  "block.minecraft.cobblestone_wall": "Balla cloiche-càsaidh",
  "block.minecraft.cobweb": "Oige",
  "block.minecraft.cocoa": "Còco",
  "block.minecraft.command_block": "Bloca-àithne",
  "block.minecraft.comparator": "Inneal-coimeis redstone",
  "block.minecraft.composter": "Inneal-compoist",
  "block.minecraft.conduit": "Seòl-phìob",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Bloca de chopar",
  "block.minecraft.copper_bulb": "Bolgan copair",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Doras copair",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Claith copair",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Clach-copair",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Doras-leigeil copair",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Gille-guirmein",
  "block.minecraft.cracked_deepslate_bricks": "Breigichean dubh-sglèata sgàinte",
  "block.minecraft.cracked_deepslate_tiles": "Leacagan dubh-sglèata sgàinte",
  "block.minecraft.cracked_nether_bricks": "Breigichean Nether sgagach",
  "block.minecraft.cracked_polished_blackstone_bricks": "Breigichean dubh-chloiche sgagach lìomhta",
  "block.minecraft.cracked_stone_bricks": "Breigichean sgagach cloiche",
  "block.minecraft.crafter": "Inneal-ciùird",
  "block.minecraft.crafting_table": "Bòrd-ciùird",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Ceann creeper",
  "block.minecraft.creeper_wall_head": "Ceann-balla Creeper",
  "block.minecraft.crimson_button": "Putan crò-dhearg",
  "block.minecraft.crimson_door": "Doras crò-dhearg",
  "block.minecraft.crimson_fence": "Feansa crò-dhearg",
  "block.minecraft.crimson_fence_gate": "Geata feansa crò-dhearg",
  "block.minecraft.crimson_fungus": "Fungas crò-dhearg",
  "block.minecraft.crimson_hanging_sign": "Soidhne-crochadh chrò-dhearg",
  "block.minecraft.crimson_hyphae": "Ròineagan crò-dhearg",
  "block.minecraft.crimson_nylium": "Nilium crò-dhearg",
  "block.minecraft.crimson_planks": "Dèilean crò-dhearg",
  "block.minecraft.crimson_pressure_plate": "Pleata-brùthaidh crò-dhearg",
  "block.minecraft.crimson_roots": "Freumhan crò-dhearg",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Soidhne chrò-dhearg",
  "block.minecraft.crimson_slab": "Leac chrò-dhearg",
  "block.minecraft.crimson_stairs": "Staidhre chrò-dhearg",
  "block.minecraft.crimson_stem": "Gas crò-dhearg",
  "block.minecraft.crimson_trapdoor": "Doras-leigeil crò-dhearg",
  "block.minecraft.crimson_wall_hanging_sign": "Soidhne-crochadh bhalla chrò-dhearg",
  "block.minecraft.crimson_wall_sign": "Soidhne-bhalla chrò-dhearg",
  "block.minecraft.crying_obsidian": "Oibsidian caoinidh",
  "block.minecraft.cut_copper": "Copar geàrrte",
  "block.minecraft.cut_copper_slab": "Leac copair gheàrrte",
  "block.minecraft.cut_copper_stairs": "Staidhre copair gheàrrte",
  "block.minecraft.cut_red_sandstone": "Clach-ghainmhich ruadh gheàrrte",
  "block.minecraft.cut_red_sandstone_slab": "Leac cloiche-gainmhich ruaidhe geàrrte",
  "block.minecraft.cut_sandstone": "Clach-ghainmhich gheàrrte",
  "block.minecraft.cut_sandstone_slab": "Leac cloiche-gainmhich geàrrte",
  "block.minecraft.cyan_banner": "Bratach shaidhean",
  "block.minecraft.cyan_bed": "Leabaidh shaidhean",
  "block.minecraft.cyan_candle": "Coinneal shaidhean",
  "block.minecraft.cyan_candle_cake": "Cèic le coinneal shaidhean",
  "block.minecraft.cyan_carpet": "Brat-ùrlair saidhean",
  "block.minecraft.cyan_concrete": "Concrait shaidhean",
  "block.minecraft.cyan_concrete_powder": "Mìn-choncrait shaidhean",
  "block.minecraft.cyan_glazed_terracotta": "Terracotta gloinichte saidhean",
  "block.minecraft.cyan_shulker_box": "Bogsa shulker saidhean",
  "block.minecraft.cyan_stained_glass": "Glainne dhathte shaidhean",
  "block.minecraft.cyan_stained_glass_pane": "Leòsan glainne saidhean",
  "block.minecraft.cyan_terracotta": "Terracotta saidhean",
  "block.minecraft.cyan_wool": "Clòimh shaidhean",
  "block.minecraft.damaged_anvil": "Innean millte",
  "block.minecraft.dandelion": "Beàrnan-brìde",
  "block.minecraft.dark_oak_button": "Putan daraich dhuirch",
  "block.minecraft.dark_oak_door": "Doras daraich dhuirch",
  "block.minecraft.dark_oak_fence": "Feansa daraich dhuirch",
  "block.minecraft.dark_oak_fence_gate": "Geata feansa daraich dhuirch",
  "block.minecraft.dark_oak_hanging_sign": "Soidhne-crochadh daraich dhuirch",
  "block.minecraft.dark_oak_leaves": "Duilleach daraich dhuirch",
  "block.minecraft.dark_oak_log": "Loga daraich dhuirch",
  "block.minecraft.dark_oak_planks": "Dèilean daraich dhuirch",
  "block.minecraft.dark_oak_pressure_plate": "Pleata-brùthaidh daraich dhuirch",
  "block.minecraft.dark_oak_sapling": "Fiùran daraich dhuirch",
  "block.minecraft.dark_oak_shelf": "Sgielp daraich dhuirch",
  "block.minecraft.dark_oak_sign": "Soidhne daraich dhuirch",
  "block.minecraft.dark_oak_slab": "Leac daraich dhuirch",
  "block.minecraft.dark_oak_stairs": "Staidhre daraich dhuirch",
  "block.minecraft.dark_oak_trapdoor": "Doras-leigeil daraich dhuirch",
  "block.minecraft.dark_oak_wall_hanging_sign": "Soidhne-crochadh bhalla daraich dhuirch",
  "block.minecraft.dark_oak_wall_sign": "Soidhne-bhalla daraich dhuirch",
  "block.minecraft.dark_oak_wood": "Fiodh daraich dhuirch",
  "block.minecraft.dark_prismarine": "Priosam-mara dorcha",
  "block.minecraft.dark_prismarine_slab": "Leac priosaim-mhara dhuirch",
  "block.minecraft.dark_prismarine_stairs": "Staidhre priosaim-mhara dhuirch",
  "block.minecraft.daylight_detector": "Lorgaire solais",
  "block.minecraft.dead_brain_coral": "Coireal-eanchainne marbh",
  "block.minecraft.dead_brain_coral_block": "Bloca coireil-eanchainne mhairbh",
  "block.minecraft.dead_brain_coral_fan": "Sgàileag coireil-eanchainne mhairbh",
  "block.minecraft.dead_brain_coral_wall_fan": "Sgàileag-bhalla coireil-eanchainne mhairbh",
  "block.minecraft.dead_bubble_coral": "Coireal-builgein marbh",
  "block.minecraft.dead_bubble_coral_block": "Bloca coireil-bhuilgein mhairbh",
  "block.minecraft.dead_bubble_coral_fan": "Sgàileag coireil-bhuilgein mhairbh",
  "block.minecraft.dead_bubble_coral_wall_fan": "Sgàileag-bhalla coireil-bhuilgein mhairbh",
  "block.minecraft.dead_bush": "Preas marbh",
  "block.minecraft.dead_fire_coral": "Coireal-teine marbh",
  "block.minecraft.dead_fire_coral_block": "Bloca coireil-teine mhairbh",
  "block.minecraft.dead_fire_coral_fan": "Sgàileag coireil-teine mhairbh",
  "block.minecraft.dead_fire_coral_wall_fan": "Sgàileag-bhalla coireil-teine mhairbh",
  "block.minecraft.dead_horn_coral": "Coireal-adhairc marbh",
  "block.minecraft.dead_horn_coral_block": "Bloca coireil-adhairc mhairbh",
  "block.minecraft.dead_horn_coral_fan": "Sgàileag coireil-adhairc mhairbh",
  "block.minecraft.dead_horn_coral_wall_fan": "Sgàileag-bhalla coireil-adhairc mhairbh",
  "block.minecraft.dead_tube_coral": "Coireal-pìoba marbh",
  "block.minecraft.dead_tube_coral_block": "Bloca coireil-phìoba mhairbh",
  "block.minecraft.dead_tube_coral_fan": "Sgàileag coireil-phìoba mhairbh",
  "block.minecraft.dead_tube_coral_wall_fan": "Sgàileag-bhalla coireil-phìoba mhairbh",
  "block.minecraft.decorated_pot": "Poit sgeadaichte",
  "block.minecraft.deepslate": "Dubh-sglèat",
  "block.minecraft.deepslate_brick_slab": "Leac bhreigichean dubh-sglèata",
  "block.minecraft.deepslate_brick_stairs": "Staidhre bhreigichean dubh-sglèata",
  "block.minecraft.deepslate_brick_wall": "Balla bhreigichean dubh-sglèata",
  "block.minecraft.deepslate_bricks": "Breigichean dubh-sglèata",
  "block.minecraft.deepslate_coal_ore": "Clach-ghuail dubh-sglèata",
  "block.minecraft.deepslate_copper_ore": "Clach-copair dubh-sglèata",
  "block.minecraft.deepslate_diamond_ore": "Clach-dhaoimein dubh-sglèata",
  "block.minecraft.deepslate_emerald_ore": "Clach-smàraige dubh-sglèata",
  "block.minecraft.deepslate_gold_ore": "Clach-òir dubh-sglèata",
  "block.minecraft.deepslate_iron_ore": "Clach-iarainn dubh-sglèata",
  "block.minecraft.deepslate_lapis_ore": "Clach cloiche-copair dubh-sglèata",
  "block.minecraft.deepslate_redstone_ore": "Clach-redstone dubh-sglèata",
  "block.minecraft.deepslate_tile_slab": "Leac de leacagan dubh-sglèata",
  "block.minecraft.deepslate_tile_stairs": "Staidhre leacagan dubh-sglèata",
  "block.minecraft.deepslate_tile_wall": "Balla leacagan dubh-sglèata",
  "block.minecraft.deepslate_tiles": "Leacagan dubh-sglèata",
  "block.minecraft.detector_rail": "Rèile-mothachaidh",
  "block.minecraft.diamond_block": "Bloca daoimein",
  "block.minecraft.diamond_ore": "Clach-daoimein",
  "block.minecraft.diorite": "Dìorait",
  "block.minecraft.diorite_slab": "Leac dìorait",
  "block.minecraft.diorite_stairs": "Staidhre dìorait",
  "block.minecraft.diorite_wall": "Balla dìorait",
  "block.minecraft.dirt": "Ùir",
  "block.minecraft.dirt_path": "Staran ùrach",
  "block.minecraft.dispenser": "Bloca tilgeil",
  "block.minecraft.dragon_egg": "Ugh dràgoin",
  "block.minecraft.dragon_head": "Ceann dràgoin",
  "block.minecraft.dragon_wall_head": "Ceann-balla dràgoin",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Bloca ceilpe thiormaichte",
  "block.minecraft.dripstone_block": "Bloca cloiche-snighe",
  "block.minecraft.dropper": "Bloca leigeil às",
  "block.minecraft.emerald_block": "Bloca smàraige",
  "block.minecraft.emerald_ore": "Clach-smàraige",
  "block.minecraft.enchanting_table": "Geas-bhòrd",
  "block.minecraft.end_gateway": "Cachaileith End",
  "block.minecraft.end_portal": "Portal End",
  "block.minecraft.end_portal_frame": "Frèama portal End",
  "block.minecraft.end_rod": "Slat End",
  "block.minecraft.end_stone": "Clach End",
  "block.minecraft.end_stone_brick_slab": "Leac bhreigichean cloiche End",
  "block.minecraft.end_stone_brick_stairs": "Staidhre bhreigichean cloiche End",
  "block.minecraft.end_stone_brick_wall": "Balla bhreigichean cloiche End",
  "block.minecraft.end_stone_bricks": "Breigichean cloiche End",
  "block.minecraft.ender_chest": "Ciste Ender",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Copar lom",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Doras copair fosgailte",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Copar geàrrte lom",
  "block.minecraft.exposed_cut_copper_slab": "Leac copair luim gheàrrte",
  "block.minecraft.exposed_cut_copper_stairs": "Staidhre copair luim gheàrrte",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Fearann-tuathanais",
  "block.minecraft.fern": "Raineach",
  "block.minecraft.fire": "Teine",
  "block.minecraft.fire_coral": "Coireal-teine",
  "block.minecraft.fire_coral_block": "Bloca coireil-teine",
  "block.minecraft.fire_coral_fan": "Sgàileag coireil-teine",
  "block.minecraft.fire_coral_wall_fan": "Sgàileag-bhalla coireil-teine",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Bòrd fleistearachd",
  "block.minecraft.flower_pot": "Poit-fhlùir",
  "block.minecraft.flowering_azalea": "Asàilia fo bhlàth",
  "block.minecraft.flowering_azalea_leaves": "Duilleach asàilia fo bhlàth",
  "block.minecraft.frogspawn": "Sgeith-losgainn",
  "block.minecraft.frosted_ice": "Deigh reòthta",
  "block.minecraft.furnace": "Fùirneis",
  "block.minecraft.gilded_blackstone": "Dubh-chlach òraichte",
  "block.minecraft.glass": "Glainne",
  "block.minecraft.glass_pane": "Leòsan glainne",
  "block.minecraft.glow_lichen": "Crotal-sionnachain",
  "block.minecraft.glowstone": "Clach-dhealraidh",
  "block.minecraft.gold_block": "Bloca òir",
  "block.minecraft.gold_ore": "Clach-òir",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Gaireal",
  "block.minecraft.granite_slab": "Leac gaireil",
  "block.minecraft.granite_stairs": "Staidhre gaireil",
  "block.minecraft.granite_wall": "Balla gaireil",
  "block.minecraft.grass": "Feur",
  "block.minecraft.grass_block": "Bloca feòir",
  "block.minecraft.gravel": "Grinneal",
  "block.minecraft.gray_banner": "Bratach ghlas",
  "block.minecraft.gray_bed": "Leabaidh ghlas",
  "block.minecraft.gray_candle": "Coinneal ghlas",
  "block.minecraft.gray_candle_cake": "Cèic le coinneal ghlas",
  "block.minecraft.gray_carpet": "Brat-ùrlair glas",
  "block.minecraft.gray_concrete": "Concrait ghlas",
  "block.minecraft.gray_concrete_powder": "Mìn-choncrait ghlas",
  "block.minecraft.gray_glazed_terracotta": "Terracotta gloinichte glas",
  "block.minecraft.gray_shulker_box": "Bogsa shulker glas",
  "block.minecraft.gray_stained_glass": "Glainne dhathte ghlas",
  "block.minecraft.gray_stained_glass_pane": "Leòsan glainne glas",
  "block.minecraft.gray_terracotta": "Terracotta glas",
  "block.minecraft.gray_wool": "Clòimh ghlas",
  "block.minecraft.green_banner": "Bratach uaine",
  "block.minecraft.green_bed": "Leabaidh uaine",
  "block.minecraft.green_candle": "Coinneal uaine",
  "block.minecraft.green_candle_cake": "Cèic le coinneal uaine",
  "block.minecraft.green_carpet": "Brat-ùrlair uaine",
  "block.minecraft.green_concrete": "Concrait uaine",
  "block.minecraft.green_concrete_powder": "Mìn-choncrait uaine",
  "block.minecraft.green_glazed_terracotta": "Terracotta gloinichte uaine",
  "block.minecraft.green_shulker_box": "Bogsa shulker uaine",
  "block.minecraft.green_stained_glass": "Glainne dhathte uaine",
  "block.minecraft.green_stained_glass_pane": "Leòsan glainne uaine",
  "block.minecraft.green_terracotta": "Terracotta uaine",
  "block.minecraft.green_wool": "Clòimh uaine",
  "block.minecraft.grindstone": "Clach-bhleith",
  "block.minecraft.hanging_roots": "Freumhan crochaidh",
  "block.minecraft.hay_block": "Bèile feòir",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Pleata-brùthaidh le cuideam trom",
  "block.minecraft.honey_block": "Bloca meala",
  "block.minecraft.honeycomb_block": "Bloca cìre-meala",
  "block.minecraft.hopper": "Drabhailt",
  "block.minecraft.horn_coral": "Coireal-adhairc",
  "block.minecraft.horn_coral_block": "Bloca coireil-adhairc",
  "block.minecraft.horn_coral_fan": "Sgàileag coireil-adhairc",
  "block.minecraft.horn_coral_wall_fan": "Sgàileag-bhalla coireil-adhairc",
  "block.minecraft.ice": "Deigh",
  "block.minecraft.infested_chiseled_stone_bricks": "Breigichean fiolanach cloiche gilbichte",
  "block.minecraft.infested_cobblestone": "Clach-chàsaidh fhiolanach",
  "block.minecraft.infested_cracked_stone_bricks": "Breigichean fiolanach sgagach cloiche",
  "block.minecraft.infested_deepslate": "Dubh-sglèat fiolanach",
  "block.minecraft.infested_mossy_stone_bricks": "Breigichean fiolanach cloiche còinneachail",
  "block.minecraft.infested_stone": "Clach fhiolanach",
  "block.minecraft.infested_stone_bricks": "Breigichean fiolanach cloiche",
  "block.minecraft.iron_bars": "Bàraichean iarainn",
  "block.minecraft.iron_block": "Bloca iarainn",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Doras iarainn",
  "block.minecraft.iron_ore": "Clach-iarainn",
  "block.minecraft.iron_trapdoor": "Doras-leigeil iarainn",
  "block.minecraft.jack_o_lantern": "Peapag Shamhna",
  "block.minecraft.jigsaw": "Bloca mhìrean-measgte",
  "block.minecraft.jukebox": "Inneal-chlàr",
  "block.minecraft.jungle_button": "Putan dlùth-choille",
  "block.minecraft.jungle_door": "Doras dlùth-choille",
  "block.minecraft.jungle_fence": "Feansa dlùth-choille",
  "block.minecraft.jungle_fence_gate": "Geata feansa dlùth-choille",
  "block.minecraft.jungle_hanging_sign": "Soidhne-crochadh dlùth-choille",
  "block.minecraft.jungle_leaves": "Duilleach dlùth-choille",
  "block.minecraft.jungle_log": "Loga dlùth-choille",
  "block.minecraft.jungle_planks": "Dèilean dlùth-choille",
  "block.minecraft.jungle_pressure_plate": "Pleata-brùthaidh dlùth-choille",
  "block.minecraft.jungle_sapling": "Fiùran dlùth-choille",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Soidhne dlùth-choille",
  "block.minecraft.jungle_slab": "Leac dlùth-choille",
  "block.minecraft.jungle_stairs": "Staidhre dlùth-choille",
  "block.minecraft.jungle_trapdoor": "Doras-leigeil dlùth-choille",
  "block.minecraft.jungle_wall_hanging_sign": "Soidhne-crochadh bhalla dlùth-choille",
  "block.minecraft.jungle_wall_sign": "Soidhne-bhalla dlùth-choille",
  "block.minecraft.jungle_wood": "Fiodh dlùth-choille",
  "block.minecraft.kelp": "Ceilp",
  "block.minecraft.kelp_plant": "Lus ceilpe",
  "block.minecraft.ladder": "Fàradh",
  "block.minecraft.lantern": "Lòchran",
  "block.minecraft.lapis_block": "Bloca de chloich-chopair",
  "block.minecraft.lapis_ore": "Clach cloiche-copair",
  "block.minecraft.large_amethyst_bud": "Gugag mhòr amaitist",
  "block.minecraft.large_fern": "Raineach mhòr",
  "block.minecraft.lava": "Làbha",
  "block.minecraft.lava_cauldron": "Coire làbha",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Leatran",
  "block.minecraft.lever": "Luamhan",
  "block.minecraft.light": "Solas",
  "block.minecraft.light_blue_banner": "Bratach bhàn-ghorm",
  "block.minecraft.light_blue_bed": "Leabaidh bhàn-ghorm",
  "block.minecraft.light_blue_candle": "Coinneal bhàn-ghorm",
  "block.minecraft.light_blue_candle_cake": "Cèic le coinneal bhàn-ghorm",
  "block.minecraft.light_blue_carpet": "Brat-ùrlair bàn-ghorm",
  "block.minecraft.light_blue_concrete": "Concrait bhàn-ghorm",
  "block.minecraft.light_blue_concrete_powder": "Mìn-choncrait bhàn-ghorm",
  "block.minecraft.light_blue_glazed_terracotta": "Terracotta gloinichte bàn-ghorm",
  "block.minecraft.light_blue_shulker_box": "Bogsa shulker bàn-ghorm",
  "block.minecraft.light_blue_stained_glass": "Glainne dhathte bhàn-ghorm",
  "block.minecraft.light_blue_stained_glass_pane": "Leòsan glainne bàn-ghorm",
  "block.minecraft.light_blue_terracotta": "Terracotta bàn-ghorm",
  "block.minecraft.light_blue_wool": "Clòimh bhàn-ghorm",
  "block.minecraft.light_gray_banner": "Bratach liath",
  "block.minecraft.light_gray_bed": "Leabaidh liath",
  "block.minecraft.light_gray_candle": "Coinneal liath",
  "block.minecraft.light_gray_candle_cake": "Cèic le coinneal liath",
  "block.minecraft.light_gray_carpet": "Brat-ùrlair liath",
  "block.minecraft.light_gray_concrete": "Concrait liath",
  "block.minecraft.light_gray_concrete_powder": "Mìn-choncrait liath",
  "block.minecraft.light_gray_glazed_terracotta": "Terracotta gloinichte liath",
  "block.minecraft.light_gray_shulker_box": "Bogsa shulker liath",
  "block.minecraft.light_gray_stained_glass": "Glainne dhathte liath",
  "block.minecraft.light_gray_stained_glass_pane": "Leòsan glainne liath",
  "block.minecraft.light_gray_terracotta": "Terracotta liath",
  "block.minecraft.light_gray_wool": "Clòimh liath",
  "block.minecraft.light_weighted_pressure_plate": "Pleata-brùthaidh le cuideam aotrom",
  "block.minecraft.lightning_rod": "Slat-dhealanaich",
  "block.minecraft.lilac": "Liath-ghorm",
  "block.minecraft.lily_of_the_valley": "Lilidh nan lòn",
  "block.minecraft.lily_pad": "Duilleag-bhàthte",
  "block.minecraft.lime_banner": "Bratach bhàn-uaine",
  "block.minecraft.lime_bed": "Leabaidh bhàn-uaine",
  "block.minecraft.lime_candle": "Coinneal bhàn-uaine",
  "block.minecraft.lime_candle_cake": "Cèic le coinneal bhàn-uaine",
  "block.minecraft.lime_carpet": "Brat-ùrlair bàn-uaine",
  "block.minecraft.lime_concrete": "Concrait bhàn-uaine",
  "block.minecraft.lime_concrete_powder": "Mìn-choncrait bhàn-uaine",
  "block.minecraft.lime_glazed_terracotta": "Terracotta gloinichte bàn-uaine",
  "block.minecraft.lime_shulker_box": "Bogsa shulker bàn-uaine",
  "block.minecraft.lime_stained_glass": "Glainne dhathte bàn-uaine",
  "block.minecraft.lime_stained_glass_pane": "Leòsan glainne bàn-uaine",
  "block.minecraft.lime_terracotta": "Terracotta bàn-uaine",
  "block.minecraft.lime_wool": "Clòimh bhàn-uaine",
  "block.minecraft.lodestone": "Clach-iùil",
  "block.minecraft.loom": "Beart-fhighe",
  "block.minecraft.magenta_banner": "Bratach mhaidèanta",
  "block.minecraft.magenta_bed": "Leabaidh mhaidèanta",
  "block.minecraft.magenta_candle": "Coinneal mhaidèanta",
  "block.minecraft.magenta_candle_cake": "Cèic le coinneal mhaidèanta",
  "block.minecraft.magenta_carpet": "Brat-ùrlair maidèanta",
  "block.minecraft.magenta_concrete": "Concrait mhaidèanta",
  "block.minecraft.magenta_concrete_powder": "Mìn-choncrait mhaidèanta",
  "block.minecraft.magenta_glazed_terracotta": "Terracotta gloinichte maidèanta",
  "block.minecraft.magenta_shulker_box": "Bogsa shulker maidèanta",
  "block.minecraft.magenta_stained_glass": "Glainne dhathte mhaidèanta",
  "block.minecraft.magenta_stained_glass_pane": "Leòsan glainne maidèanta",
  "block.minecraft.magenta_terracotta": "Terracotta maidèanta",
  "block.minecraft.magenta_wool": "Clòimh mhaidèanta",
  "block.minecraft.magma_block": "Bloca magma",
  "block.minecraft.mangrove_button": "Putan Mangarbh",
  "block.minecraft.mangrove_door": "Doras Mangarbh",
  "block.minecraft.mangrove_fence": "Feansa Mangarbh",
  "block.minecraft.mangrove_fence_gate": "Geata feansa mangarbh",
  "block.minecraft.mangrove_hanging_sign": "Soidhne-crochadh mangarbh",
  "block.minecraft.mangrove_leaves": "Duilleach Mangarbh",
  "block.minecraft.mangrove_log": "Loga mangarbh",
  "block.minecraft.mangrove_planks": "Dèilean mangarbh",
  "block.minecraft.mangrove_pressure_plate": "Pleata-brùthaidh mangarbh",
  "block.minecraft.mangrove_propagule": "Faillean mangarbh",
  "block.minecraft.mangrove_roots": "Freumhan mangarbh",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Soidhne mangarbh",
  "block.minecraft.mangrove_slab": "Leac Mangarbh",
  "block.minecraft.mangrove_stairs": "Staidhre Mangarbh",
  "block.minecraft.mangrove_trapdoor": "Doras-leigeil mangarbh",
  "block.minecraft.mangrove_wall_hanging_sign": "Soidhne-crochadh bhalla mangarbh",
  "block.minecraft.mangrove_wall_sign": "Soidhne-bhalla mangarbh",
  "block.minecraft.mangrove_wood": "Fiodh mangarbh",
  "block.minecraft.medium_amethyst_bud": "Gucag mheadhanach amaitist",
  "block.minecraft.melon": "Meal-bhuc",
  "block.minecraft.melon_stem": "Gas meal-bhuic",
  "block.minecraft.moss_block": "Bloca còinnich",
  "block.minecraft.moss_carpet": "Brat-ùrlair còinnich",
  "block.minecraft.mossy_cobblestone": "Clach-chàsaidh chòinneachail",
  "block.minecraft.mossy_cobblestone_slab": "Leac cloiche-càsaidh còinneachail",
  "block.minecraft.mossy_cobblestone_stairs": "Staidhre cloiche-càsaidh còinneachail",
  "block.minecraft.mossy_cobblestone_wall": "Balla cloiche-càsaidh còinneachail",
  "block.minecraft.mossy_stone_brick_slab": "Leac bhreigichean cloiche còinneachail",
  "block.minecraft.mossy_stone_brick_stairs": "Staidhre bhreigichean cloiche còinneachail",
  "block.minecraft.mossy_stone_brick_wall": "Balla bhreigichean cloiche còinneachail",
  "block.minecraft.mossy_stone_bricks": "Breigichean cloiche còinneachail",
  "block.minecraft.moving_piston": "Loinid ghluasadach",
  "block.minecraft.mud": "Eabar",
  "block.minecraft.mud_brick_slab": "Leac bhreigichean eabar",
  "block.minecraft.mud_brick_stairs": "Staidhre bhreigichean eabar",
  "block.minecraft.mud_brick_wall": "Balla bhreigichean eabar",
  "block.minecraft.mud_bricks": "Breigichean eabar",
  "block.minecraft.muddy_mangrove_roots": "Freumhan eabarach mangarbh",
  "block.minecraft.mushroom_stem": "Gas balgain-bhuachair",
  "block.minecraft.mycelium": "Mycelium",
  "block.minecraft.nether_brick_fence": "Feansa bhreigichean Nether",
  "block.minecraft.nether_brick_slab": "Leac bhreigichean Nether",
  "block.minecraft.nether_brick_stairs": "Staidhre bhreigichean Nether",
  "block.minecraft.nether_brick_wall": "Balla bhreigichean Nether",
  "block.minecraft.nether_bricks": "Breigichean Nether",
  "block.minecraft.nether_gold_ore": "Clach-òir Nether",
  "block.minecraft.nether_portal": "Portal Nether",
  "block.minecraft.nether_quartz_ore": "Clach-eiteige Nether",
  "block.minecraft.nether_sprouts": "Buinneagan Nether",
  "block.minecraft.nether_wart": "Lus Nether",
  "block.minecraft.nether_wart_block": "Bloca lusa Nether",
  "block.minecraft.netherite_block": "Bloca Netherit",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloca-phong",
  "block.minecraft.oak_button": "Putan daraich",
  "block.minecraft.oak_door": "Doras daraich",
  "block.minecraft.oak_fence": "Feansa daraich",
  "block.minecraft.oak_fence_gate": "Geata feansa daraich",
  "block.minecraft.oak_hanging_sign": "Soidhne-crochadh daraich",
  "block.minecraft.oak_leaves": "Duilleach daraich",
  "block.minecraft.oak_log": "Loga daraich",
  "block.minecraft.oak_planks": "Dèilean daraich",
  "block.minecraft.oak_pressure_plate": "Pleata-brùthaidh daraich",
  "block.minecraft.oak_sapling": "Fiùran daraich",
  "block.minecraft.oak_shelf": "Sgielp daraich",
  "block.minecraft.oak_sign": "Soidhne daraich",
  "block.minecraft.oak_slab": "Leac daraich",
  "block.minecraft.oak_stairs": "Staidhre daraich",
  "block.minecraft.oak_trapdoor": "Doras-leigeil daraich",
  "block.minecraft.oak_wall_hanging_sign": "Soidhne-crochadh bhalla daraich",
  "block.minecraft.oak_wall_sign": "Soidhne-bhalla daraich",
  "block.minecraft.oak_wood": "Fiodh daraich",
  "block.minecraft.observer": "Coimheadaiche",
  "block.minecraft.obsidian": "Oibsidian",
  "block.minecraft.ochre_froglight": "Solas-losgainn buidhe",
  "block.minecraft.ominous_banner": "Bratach bhagarrach",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Bratach orains",
  "block.minecraft.orange_bed": "Leabaidh orains",
  "block.minecraft.orange_candle": "Coinneal orains",
  "block.minecraft.orange_candle_cake": "Cèic le coinneal orains",
  "block.minecraft.orange_carpet": "Brat-ùrlair orains",
  "block.minecraft.orange_concrete": "Concrait orains",
  "block.minecraft.orange_concrete_powder": "Mìn-choncrait orains",
  "block.minecraft.orange_glazed_terracotta": "Terracotta gloinichte orains",
  "block.minecraft.orange_shulker_box": "Bogsa shulker orains",
  "block.minecraft.orange_stained_glass": "Glainne dhathte orains",
  "block.minecraft.orange_stained_glass_pane": "Leòsan glainne orains",
  "block.minecraft.orange_terracotta": "Terracotta orains",
  "block.minecraft.orange_tulip": "Tiuilip orains",
  "block.minecraft.orange_wool": "Clòimh orains",
  "block.minecraft.oxeye_daisy": "Neòinean-mòr",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Copar meirgte",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Copar geàrrte meirgte",
  "block.minecraft.oxidized_cut_copper_slab": "Leac copair mheirgte gheàrrte",
  "block.minecraft.oxidized_cut_copper_stairs": "Staidhre copair mheirgte gheàrrte",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Deigh dhlùth",
  "block.minecraft.packed_mud": "Eabar dhlùth",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Putan daraich bhàin",
  "block.minecraft.pale_oak_door": "Doras daraich bhàin",
  "block.minecraft.pale_oak_fence": "Feansa daraich bhàin",
  "block.minecraft.pale_oak_fence_gate": "Geata feansa daraich bhàin",
  "block.minecraft.pale_oak_hanging_sign": "Soidhne-crochadh daraich bhàin",
  "block.minecraft.pale_oak_leaves": "Duilleach daraich bhàin",
  "block.minecraft.pale_oak_log": "Loga daraich bhàin",
  "block.minecraft.pale_oak_planks": "Dèilean daraich bhàin",
  "block.minecraft.pale_oak_pressure_plate": "Pleata-brùthaidh daraich bhàin",
  "block.minecraft.pale_oak_sapling": "Fiùran daraich bhàin",
  "block.minecraft.pale_oak_shelf": "Sgielp daraich bhàin",
  "block.minecraft.pale_oak_sign": "Soidhne daraich bhàin",
  "block.minecraft.pale_oak_slab": "Leac daraich bhàin",
  "block.minecraft.pale_oak_stairs": "Staidhre daraich bhàin",
  "block.minecraft.pale_oak_trapdoor": "Doras-leigeil daraich bhàin",
  "block.minecraft.pale_oak_wall_hanging_sign": "Soidhne-crochadh bhalla daraich bhàin",
  "block.minecraft.pale_oak_wall_sign": "Soidhne-bhalla daraich bhàin",
  "block.minecraft.pale_oak_wood": "Fiodh daraich bhàin",
  "block.minecraft.pearlescent_froglight": "Solas-losgainn gleansach",
  "block.minecraft.peony": "Meacan-easa",
  "block.minecraft.petrified_oak_slab": "Leac daraich a chaidh na chloich",
  "block.minecraft.piglin_head": "Ceann piglin",
  "block.minecraft.piglin_wall_head": "Claigeann-balla piglin",
  "block.minecraft.pink_banner": "Bratach bhàn-dearg",
  "block.minecraft.pink_bed": "Leabaidh bhàn-dearg",
  "block.minecraft.pink_candle": "Coinneal bhàn-dearg",
  "block.minecraft.pink_candle_cake": "Cèic le coinneal bhàn-dearg",
  "block.minecraft.pink_carpet": "Brat-ùrlair bàn-dearg",
  "block.minecraft.pink_concrete": "Concrait bhàn-dearg",
  "block.minecraft.pink_concrete_powder": "Mìn-choncrait bhàn-dearg",
  "block.minecraft.pink_glazed_terracotta": "Terracotta gloinichte bàn-dearg",
  "block.minecraft.pink_petals": "Flùragan bhàn-dhearg",
  "block.minecraft.pink_shulker_box": "Bogsa shulker bàn-dearg",
  "block.minecraft.pink_stained_glass": "Glainne dhathte bhàn-dearg",
  "block.minecraft.pink_stained_glass_pane": "Leòsan glainne bàn-dearg",
  "block.minecraft.pink_terracotta": "Terracotta bàn-dearg",
  "block.minecraft.pink_tulip": "Tiuilip bhàn-dearg",
  "block.minecraft.pink_wool": "Clòimh bhàn-dearg",
  "block.minecraft.piston": "Loinid",
  "block.minecraft.piston_head": "Ceann loinide",
  "block.minecraft.pitcher_crop": "Barr lus-pige",
  "block.minecraft.pitcher_plant": "Lus-pige",
  "block.minecraft.player_head": "Ceann cluicheadair",
  "block.minecraft.player_head.named": "Ceann %s",
  "block.minecraft.player_wall_head": "Claigeann-balla cluicheadair",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Clach-shnighe bhiorach",
  "block.minecraft.polished_andesite": "Andasait lìomhta",
  "block.minecraft.polished_andesite_slab": "Leac andasait lìomhta",
  "block.minecraft.polished_andesite_stairs": "Staidhre andasait lìomhta",
  "block.minecraft.polished_basalt": "Basalt lìomhta",
  "block.minecraft.polished_blackstone": "Dubh-chlach lìomhta",
  "block.minecraft.polished_blackstone_brick_slab": "Leac bhreigichean dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_brick_stairs": "Staidhre bhreigichean dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_brick_wall": "Balla bhreigichean dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_bricks": "Breigichean dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_button": "Putan dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_pressure_plate": "Pleata-brùthaidh dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_slab": "Leac dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_stairs": "Staidhre dubh-chloiche lìomhta",
  "block.minecraft.polished_blackstone_wall": "Balla dubh-chloiche lìomhta",
  "block.minecraft.polished_deepslate": "Dubh-sglèat lìomhta",
  "block.minecraft.polished_deepslate_slab": "Leac dubh-sglèata lìomhta",
  "block.minecraft.polished_deepslate_stairs": "Staidhre dubh-sglèata lìomhta",
  "block.minecraft.polished_deepslate_wall": "Balla dubh-sglèata lìomhta",
  "block.minecraft.polished_diorite": "Dìorait lìomhta",
  "block.minecraft.polished_diorite_slab": "Leac dìorait lìomhta",
  "block.minecraft.polished_diorite_stairs": "Staidhre dìorait lìomhta",
  "block.minecraft.polished_granite": "Gaireal lìomhta",
  "block.minecraft.polished_granite_slab": "Leac gaireil lìomhta",
  "block.minecraft.polished_granite_stairs": "Staidhre gaireil lìomhta",
  "block.minecraft.polished_tuff": "Tuf lìomhta",
  "block.minecraft.polished_tuff_slab": "Leac tuf lìomhta",
  "block.minecraft.polished_tuff_stairs": "Staidhre tuf lìomhta",
  "block.minecraft.polished_tuff_wall": "Balla tuf lìomhta",
  "block.minecraft.poppy": "Crom-lus",
  "block.minecraft.potatoes": "Buntàta",
  "block.minecraft.potted_acacia_sapling": "Fiùran sitta ann am poit",
  "block.minecraft.potted_allium": "Uinnean Pearsach ann am poit",
  "block.minecraft.potted_azalea_bush": "Asàilia ann am poit",
  "block.minecraft.potted_azure_bluet": "Gorm-lus ann am poit",
  "block.minecraft.potted_bamboo": "Bambù ann am poit",
  "block.minecraft.potted_birch_sapling": "Fiùran beithe ann am poit",
  "block.minecraft.potted_blue_orchid": "Magairle ghorm ann am poit",
  "block.minecraft.potted_brown_mushroom": "Balgan-buachair donn ann am poit",
  "block.minecraft.potted_cactus": "Cactas ann am poit",
  "block.minecraft.potted_cherry_sapling": "Fiùran siris ann am poit",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Gille-guirmein ann am poit",
  "block.minecraft.potted_crimson_fungus": "Fungas crò-dhearg ann am poit",
  "block.minecraft.potted_crimson_roots": "Freumhan crò-dhearg ann am poit",
  "block.minecraft.potted_dandelion": "Beàrnan-brìde ann am poit",
  "block.minecraft.potted_dark_oak_sapling": "Fiùran daraich dhuirch ann am poit",
  "block.minecraft.potted_dead_bush": "Preas marbh ann am poit",
  "block.minecraft.potted_fern": "Raineach ann am poit",
  "block.minecraft.potted_flowering_azalea_bush": "Asàilia fo bhlàth ann am poit",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Fiùran dlùth-choille ann am poit",
  "block.minecraft.potted_lily_of_the_valley": "Lilidh nan lòn ann am poit",
  "block.minecraft.potted_mangrove_propagule": "Faillean mangarbh ann am poit",
  "block.minecraft.potted_oak_sapling": "Fiùran daraich ann am poit",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Tiuilip orains ann am poit",
  "block.minecraft.potted_oxeye_daisy": "Neòinean-mòr ann am poit",
  "block.minecraft.potted_pale_oak_sapling": "Poit de Fiùran daraich bhàin",
  "block.minecraft.potted_pink_tulip": "Tiuilip bhàn-dearg ann am poit",
  "block.minecraft.potted_poppy": "Crom-lus ann am poit",
  "block.minecraft.potted_red_mushroom": "Balgan-buachair dearg ann am poit",
  "block.minecraft.potted_red_tulip": "Tiuilip dhearg ann am poit",
  "block.minecraft.potted_spruce_sapling": "Fiùran giuthais ann am poit",
  "block.minecraft.potted_torchflower": "Fhlùir-lòchran ann am poit",
  "block.minecraft.potted_warped_fungus": "Fungas saobh ann am poit",
  "block.minecraft.potted_warped_roots": "Freumhan saobha ann am poit",
  "block.minecraft.potted_white_tulip": "Tiuilip bhàn ann am poit",
  "block.minecraft.potted_wither_rose": "Ròs Wither ann am poit",
  "block.minecraft.powder_snow": "Sneachd mìn-phronn",
  "block.minecraft.powder_snow_cauldron": "Coire sneachda mhìn-phruinn",
  "block.minecraft.powered_rail": "Rèile-dealain",
  "block.minecraft.prismarine": "Priosam-mara",
  "block.minecraft.prismarine_brick_slab": "Leac bhreigichean priosaim-mhara",
  "block.minecraft.prismarine_brick_stairs": "Staidhre bhreigichean priosaim-mhara",
  "block.minecraft.prismarine_bricks": "Breigichean priosaim-mhara",
  "block.minecraft.prismarine_slab": "Leac priosaim-mhara",
  "block.minecraft.prismarine_stairs": "Staidhre priosaim-mhara",
  "block.minecraft.prismarine_wall": "Balla priosaim-mhara",
  "block.minecraft.pumpkin": "Peapag",
  "block.minecraft.pumpkin_stem": "Gas peapaige",
  "block.minecraft.purple_banner": "Bratach phurpaidh",
  "block.minecraft.purple_bed": "Leabaidh phurpaidh",
  "block.minecraft.purple_candle": "Coinneal phurpaidh",
  "block.minecraft.purple_candle_cake": "Cèic le coinneal phurpaidh",
  "block.minecraft.purple_carpet": "Brat-ùrlair purpaidh",
  "block.minecraft.purple_concrete": "Concrait phurpaidh",
  "block.minecraft.purple_concrete_powder": "Mìn-choncrait phurpaidh",
  "block.minecraft.purple_glazed_terracotta": "Terracotta gloinichte purpaidh",
  "block.minecraft.purple_shulker_box": "Bogsa shulker purpaidh",
  "block.minecraft.purple_stained_glass": "Glainne dhathte phurpaidh",
  "block.minecraft.purple_stained_glass_pane": "Leòsan glainne purpaidh",
  "block.minecraft.purple_terracotta": "Terracotta purpaidh",
  "block.minecraft.purple_wool": "Clòimh phurpaidh",
  "block.minecraft.purpur_block": "Bloca purpur",
  "block.minecraft.purpur_pillar": "Colbh purpur",
  "block.minecraft.purpur_slab": "Leac purpur",
  "block.minecraft.purpur_stairs": "Staidhre purpur",
  "block.minecraft.quartz_block": "Bloca eiteige",
  "block.minecraft.quartz_bricks": "Breigichean eiteige",
  "block.minecraft.quartz_pillar": "Colbh eiteige",
  "block.minecraft.quartz_slab": "Leac eiteige",
  "block.minecraft.quartz_stairs": "Staidhre eiteige",
  "block.minecraft.rail": "Rèile",
  "block.minecraft.raw_copper_block": "Bloca de chopar amh",
  "block.minecraft.raw_gold_block": "Bloca de dh'òr amh",
  "block.minecraft.raw_iron_block": "Bloca de dh'iarann amh",
  "block.minecraft.red_banner": "Bratach dhearg",
  "block.minecraft.red_bed": "Leabaidh dhearg",
  "block.minecraft.red_candle": "Coinneal dhearg",
  "block.minecraft.red_candle_cake": "Cèic le coinneal dhearg",
  "block.minecraft.red_carpet": "Brat-ùrlair dearg",
  "block.minecraft.red_concrete": "Concrait dhearg",
  "block.minecraft.red_concrete_powder": "Mìn-choncrait dhearg",
  "block.minecraft.red_glazed_terracotta": "Terracotta gloinichte dearg",
  "block.minecraft.red_mushroom": "Balgan-buachair dearg",
  "block.minecraft.red_mushroom_block": "Bloca balgain-bhuachair dheirg",
  "block.minecraft.red_nether_brick_slab": "Leac bhreigichean ruadha Nether",
  "block.minecraft.red_nether_brick_stairs": "Staidhre bhreigichean ruadha Nether",
  "block.minecraft.red_nether_brick_wall": "Balla bhreigichean ruadha Nether",
  "block.minecraft.red_nether_bricks": "Breigichean ruadha Nether",
  "block.minecraft.red_sand": "Gainmheach ruadh",
  "block.minecraft.red_sandstone": "Clach-ghainmhich ruadh",
  "block.minecraft.red_sandstone_slab": "Leac cloiche-gainmhich ruaidhe",
  "block.minecraft.red_sandstone_stairs": "Staidhre cloiche-gainmhich ruaidh",
  "block.minecraft.red_sandstone_wall": "Balla cloiche-gainmhich ruaidhe",
  "block.minecraft.red_shulker_box": "Bogsa shulker dearg",
  "block.minecraft.red_stained_glass": "Glainne dhathte dhearg",
  "block.minecraft.red_stained_glass_pane": "Leòsan glainne dearg",
  "block.minecraft.red_terracotta": "Terracotta dearg",
  "block.minecraft.red_tulip": "Tiuilip dhearg",
  "block.minecraft.red_wool": "Clòimh dhearg",
  "block.minecraft.redstone_block": "Bloca redstone",
  "block.minecraft.redstone_lamp": "Lampa redstone",
  "block.minecraft.redstone_ore": "Clach-redstone",
  "block.minecraft.redstone_torch": "Lòchran redstone",
  "block.minecraft.redstone_wall_torch": "Lòchran-balla redstone",
  "block.minecraft.redstone_wire": "Uèir redstone",
  "block.minecraft.reinforced_deepslate": "Dubh-sglèat stormaichte",
  "block.minecraft.repeater": "Ath-chraoladair redstone",
  "block.minecraft.repeating_command_block": "Bloca-àithne ath-dhèanaimh",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Acair ath-ghintinn",
  "block.minecraft.rooted_dirt": "Ùir fhreumhaichte",
  "block.minecraft.rose_bush": "Preas nan ròs",
  "block.minecraft.sand": "Gainmheach",
  "block.minecraft.sandstone": "Clach-ghainmhich",
  "block.minecraft.sandstone_slab": "Leac cloiche-gainmhich",
  "block.minecraft.sandstone_stairs": "Staidhre cloiche-gainmhich",
  "block.minecraft.sandstone_wall": "Balla cloiche-gainmhich",
  "block.minecraft.scaffolding": "Sgafallachd",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catailist sculk",
  "block.minecraft.sculk_sensor": "Mothaichear sculk",
  "block.minecraft.sculk_shrieker": "Sgairteadair sculk",
  "block.minecraft.sculk_vein": "Fèith-fhala sculk",
  "block.minecraft.sea_lantern": "Lòchran-mara",
  "block.minecraft.sea_pickle": "Piceal na mara",
  "block.minecraft.seagrass": "Bilearach-mara",
  "block.minecraft.set_spawn": "Shuidhicheadh ionad ath-ghintinn",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Solas-buachair",
  "block.minecraft.shulker_box": "Bogsa shulker",
  "block.minecraft.skeleton_skull": "Claigeann cnàimhnich",
  "block.minecraft.skeleton_wall_skull": "Claigeann-balla cnàimhnich",
  "block.minecraft.slime_block": "Bloca eabair",
  "block.minecraft.small_amethyst_bud": "Gucag bheag amaitist",
  "block.minecraft.small_dripleaf": "Duille-shnighe bheag",
  "block.minecraft.smithing_table": "Bòrd goibhneachd",
  "block.minecraft.smoker": "Smocair",
  "block.minecraft.smooth_basalt": "Basalt rèidh",
  "block.minecraft.smooth_quartz": "Bloc èiteige rèidh",
  "block.minecraft.smooth_quartz_slab": "Leac eiteige rèidhe",
  "block.minecraft.smooth_quartz_stairs": "Staidhre eiteige rèidhe",
  "block.minecraft.smooth_red_sandstone": "Clach-ghainmhich ruadh rèidh",
  "block.minecraft.smooth_red_sandstone_slab": "Leac cloiche-gainmhich ruaidhe rèidhe",
  "block.minecraft.smooth_red_sandstone_stairs": "Staidhre cloiche-gainmhich ruaidhe rèidhe",
  "block.minecraft.smooth_sandstone": "Clach-ghainmhich rèidh",
  "block.minecraft.smooth_sandstone_slab": "Leac cloiche-gainmhich rèidhe",
  "block.minecraft.smooth_sandstone_stairs": "Staidhre cloiche-gainmhich rèidhe",
  "block.minecraft.smooth_stone": "Clach rèidh",
  "block.minecraft.smooth_stone_slab": "Leac cloiche rèidh",
  "block.minecraft.sniffer_egg": "Ugh-snotair",
  "block.minecraft.snow": "Sneachd",
  "block.minecraft.snow_block": "Bloca sneachda",
  "block.minecraft.soul_campfire": "Teine-anama fosgailte",
  "block.minecraft.soul_fire": "Teine anama",
  "block.minecraft.soul_lantern": "Lòchran anama",
  "block.minecraft.soul_sand": "Gainmheach anama",
  "block.minecraft.soul_soil": "Ùir anama",
  "block.minecraft.soul_torch": "Lòchran anama",
  "block.minecraft.soul_wall_torch": "Lòchran-balla anama",
  "block.minecraft.spawn.not_valid": "Chan eil leabaidh-dhachaigh no acair-ath-ghintinn air a teàirrdseadh agad, air neo tha i air a bacadh",
  "block.minecraft.spawner": "Gineadair uilebheistean",
  "block.minecraft.spawner.desc1": "Nuair a bhios tu ag eadar-obrachadh le Ugh Gintinn:",
  "block.minecraft.spawner.desc2": "A 'suidheachadh seòrsa mob",
  "block.minecraft.sponge": "Spong",
  "block.minecraft.spore_blossom": "Blàth nan spòr",
  "block.minecraft.spruce_button": "Putan giuthais",
  "block.minecraft.spruce_door": "Doras giuthais",
  "block.minecraft.spruce_fence": "Feansa giuthais",
  "block.minecraft.spruce_fence_gate": "Geata feansa giuthais",
  "block.minecraft.spruce_hanging_sign": "Soidhne-crochadh giuthais",
  "block.minecraft.spruce_leaves": "Duilleach giuthais",
  "block.minecraft.spruce_log": "Loga giuthais",
  "block.minecraft.spruce_planks": "Dèilean giuthais",
  "block.minecraft.spruce_pressure_plate": "Pleata-brùthaidh giuthais",
  "block.minecraft.spruce_sapling": "Fiùran giuthais",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Soidhne giuthais",
  "block.minecraft.spruce_slab": "Leac giuthais",
  "block.minecraft.spruce_stairs": "Staidhre giuthais",
  "block.minecraft.spruce_trapdoor": "Doras-leigeil giuthais",
  "block.minecraft.spruce_wall_hanging_sign": "Soidhne-crochadh bhalla giuthais",
  "block.minecraft.spruce_wall_sign": "Soidhne-bhalla giuthais",
  "block.minecraft.spruce_wood": "Fiodh giuthais",
  "block.minecraft.sticky_piston": "Loinid-tharraing",
  "block.minecraft.stone": "Clach",
  "block.minecraft.stone_brick_slab": "Leac bhreigichean-cloiche",
  "block.minecraft.stone_brick_stairs": "Staidhre bhreigichean cloiche",
  "block.minecraft.stone_brick_wall": "Balla bhreigichean-cloiche",
  "block.minecraft.stone_bricks": "Breigichean cloiche",
  "block.minecraft.stone_button": "Putan cloiche",
  "block.minecraft.stone_pressure_plate": "Pleata-brùthaidh cloiche",
  "block.minecraft.stone_slab": "Leac cloiche",
  "block.minecraft.stone_stairs": "Staidhre cloiche",
  "block.minecraft.stonecutter": "Gearradair-cloiche",
  "block.minecraft.stripped_acacia_log": "Loga sitta rùisgte",
  "block.minecraft.stripped_acacia_wood": "Fiodh sitta rùisgte",
  "block.minecraft.stripped_bamboo_block": "Bloca bambù rùisgte",
  "block.minecraft.stripped_birch_log": "Loga beithe rùisgte",
  "block.minecraft.stripped_birch_wood": "Fiodh beithe rùisgte",
  "block.minecraft.stripped_cherry_log": "Loga siris rùisgte",
  "block.minecraft.stripped_cherry_wood": "Fiodh siris rùisgte",
  "block.minecraft.stripped_crimson_hyphae": "Ròineagan crò-dhearg rùisgte",
  "block.minecraft.stripped_crimson_stem": "Gas crò-dhearg rùisgte",
  "block.minecraft.stripped_dark_oak_log": "Loga daraich dhuirch rùisgte",
  "block.minecraft.stripped_dark_oak_wood": "Fiodh daraich dhuirch rùisgte",
  "block.minecraft.stripped_jungle_log": "Loga dlùth-choille rùisgte",
  "block.minecraft.stripped_jungle_wood": "Fiodh dlùth-choille rùisgte",
  "block.minecraft.stripped_mangrove_log": "Loga mangarbh rùisgte",
  "block.minecraft.stripped_mangrove_wood": "Fiodh mangarbh rùisgte",
  "block.minecraft.stripped_oak_log": "Loga daraich rùisgte",
  "block.minecraft.stripped_oak_wood": "Fiodh daraich rùisgte",
  "block.minecraft.stripped_pale_oak_log": "Loga daraich bhàin rùisgte",
  "block.minecraft.stripped_pale_oak_wood": "Fiodh daraich bhàin rùisgte",
  "block.minecraft.stripped_spruce_log": "Loga giuthais rùisgte",
  "block.minecraft.stripped_spruce_wood": "Fiodh giuthais rùisgte",
  "block.minecraft.stripped_warped_hyphae": "Ròineagan saobha rùisgte",
  "block.minecraft.stripped_warped_stem": "Gas saobh rùisgte",
  "block.minecraft.structure_block": "Bloca structair",
  "block.minecraft.structure_void": "Fànas structair",
  "block.minecraft.sugar_cane": "Cuilc an t-siùcair",
  "block.minecraft.sunflower": "Neòinean-grèine",
  "block.minecraft.suspicious_gravel": "Greabhal amharasach",
  "block.minecraft.suspicious_sand": "Gaineamh neònach",
  "block.minecraft.sweet_berry_bush": "Preas nan dearcan milis",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Feur Fada",
  "block.minecraft.tall_seagrass": "Bilearach-mara fada",
  "block.minecraft.target": "Targaid",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Glainne dhubhte",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Lòchran",
  "block.minecraft.torchflower": "Fhlùir-lòchran",
  "block.minecraft.torchflower_crop": "Barr fhlùir-lòchran",
  "block.minecraft.trapped_chest": "Ciste le ribe",
  "block.minecraft.trial_spawner": "Gineadair Àite na Deuchainne",
  "block.minecraft.tripwire": "Uèir-ribe",
  "block.minecraft.tripwire_hook": "Cromag uèir-ribe",
  "block.minecraft.tube_coral": "Coireal-pìoba",
  "block.minecraft.tube_coral_block": "Bloca coireil-phìoba",
  "block.minecraft.tube_coral_fan": "Sgàileag coireil-phìoba",
  "block.minecraft.tube_coral_wall_fan": "Sgàileag-bhalla coireil-phìoba",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Leac bhreigichean tuf",
  "block.minecraft.tuff_brick_stairs": "Staidhre bhreigichean tuf",
  "block.minecraft.tuff_brick_wall": "Simpler version : \"Balla breige tuff\"",
  "block.minecraft.tuff_bricks": "Breigichean tuf",
  "block.minecraft.tuff_slab": "Leac tuf",
  "block.minecraft.tuff_stairs": "Staidhre tuf",
  "block.minecraft.tuff_wall": "Balla tuf",
  "block.minecraft.turtle_egg": "Ugh turtair",
  "block.minecraft.twisting_vines": "Fìonain shnìomhanach",
  "block.minecraft.twisting_vines_plant": "Lus nam fìonan snìomhanach",
  "block.minecraft.vault": "Tasgaidh",
  "block.minecraft.verdant_froglight": "Solas-losgann gorm",
  "block.minecraft.vine": "Fìonain",
  "block.minecraft.void_air": "Adhar fànais",
  "block.minecraft.wall_torch": "Lòchran-balla",
  "block.minecraft.warped_button": "Putan saobh",
  "block.minecraft.warped_door": "Doras saobh",
  "block.minecraft.warped_fence": "Feansa saobh",
  "block.minecraft.warped_fence_gate": "Geata feansa saobh",
  "block.minecraft.warped_fungus": "Fungas saobh",
  "block.minecraft.warped_hanging_sign": "Soidhne-crochadh shaobh",
  "block.minecraft.warped_hyphae": "Ròineagan saobha",
  "block.minecraft.warped_nylium": "Nilium saobh",
  "block.minecraft.warped_planks": "Dèilean saobha",
  "block.minecraft.warped_pressure_plate": "Pleata-brùthaidh saobh",
  "block.minecraft.warped_roots": "Freumhan saobha",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Soidhne shaobh",
  "block.minecraft.warped_slab": "Leac shaobh",
  "block.minecraft.warped_stairs": "Staidhre shaobh",
  "block.minecraft.warped_stem": "Gas saobh",
  "block.minecraft.warped_trapdoor": "Doras-leigeil saobh",
  "block.minecraft.warped_wall_hanging_sign": "Soidhne-crochadh bhalla shaobh",
  "block.minecraft.warped_wall_sign": "Soidhne-bhalla shaobh",
  "block.minecraft.warped_wart_block": "Bloca lusa shaoibh",
  "block.minecraft.water": "Uisge",
  "block.minecraft.water_cauldron": "Coire uisge",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Bloca cèirte de chopar",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Copar geàrrte cèirte",
  "block.minecraft.waxed_cut_copper_slab": "Leac chèirte copair gheàrrte",
  "block.minecraft.waxed_cut_copper_stairs": "Staidhre chèirte copair gheàrrte",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Copar lom cèirte",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Doras copar lom cèirte",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Copar geàrrte lom cèirte",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Leac chèirte copair luim gheàrrte",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Staidhre chèirte copair luim gheàrrte",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Copar meirgte cèirte",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Copar geàrrte meirgte cèirte",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Leac chèirte copair mheirgte gheàrrte",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Staidhre chèirte copair mheirgte gheàrrte",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Copar ànrach cèirte",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Doras copar ànrach cèirte",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Copar geàrrte ànrach cèirte",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Leac chèirte copair ànraich gheàrrte",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Staidhre chèirte copair ànraich gheàrrte",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Copar ànrach",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Copar geàrrte ànrach",
  "block.minecraft.weathered_cut_copper_slab": "Leac copair ànraich gheàrrte",
  "block.minecraft.weathered_cut_copper_stairs": "Staidhre copair ànraich gheàrrte",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Fìonain-chaoinidh",
  "block.minecraft.weeping_vines_plant": "Lus nam fìonan-caoinidh",
  "block.minecraft.wet_sponge": "Spong fliuch",
  "block.minecraft.wheat": "Bàrr cruithneachd",
  "block.minecraft.white_banner": "Bratach gheal",
  "block.minecraft.white_bed": "Leabaidh gheal",
  "block.minecraft.white_candle": "Coinneal gheal",
  "block.minecraft.white_candle_cake": "Cèic le coinneal gheal",
  "block.minecraft.white_carpet": "Brat-ùrlair geal",
  "block.minecraft.white_concrete": "Concrait gheal",
  "block.minecraft.white_concrete_powder": "Mìn-choncrait gheal",
  "block.minecraft.white_glazed_terracotta": "Terracotta gloinichte geal",
  "block.minecraft.white_shulker_box": "Bogsa shulker geal",
  "block.minecraft.white_stained_glass": "Glainne dhathte gheal",
  "block.minecraft.white_stained_glass_pane": "Leòsan glainne geal",
  "block.minecraft.white_terracotta": "Terracotta geal",
  "block.minecraft.white_tulip": "Tiuilip bhàn",
  "block.minecraft.white_wool": "Clòimh gheal",
  "block.minecraft.wildflowers": "Flùraichean-fiadhaich",
  "block.minecraft.wither_rose": "Ròs Wither",
  "block.minecraft.wither_skeleton_skull": "Claigeann wither-chnàimhnich",
  "block.minecraft.wither_skeleton_wall_skull": "Claigeann-balla wither-chnàimhnich",
  "block.minecraft.yellow_banner": "Bratach bhuidhe",
  "block.minecraft.yellow_bed": "Leabaidh bhuidhe",
  "block.minecraft.yellow_candle": "Coinneal bhuidhe",
  "block.minecraft.yellow_candle_cake": "Cèic le coinneal bhuidhe",
  "block.minecraft.yellow_carpet": "Brat-ùrlair buidhe",
  "block.minecraft.yellow_concrete": "Concrait bhuidhe",
  "block.minecraft.yellow_concrete_powder": "Mìn-choncrait bhuidhe",
  "block.minecraft.yellow_glazed_terracotta": "Terracotta gloinichte buidhe",
  "block.minecraft.yellow_shulker_box": "Bogsa shulker buidhe",
  "block.minecraft.yellow_stained_glass": "Glainne dhathte bhuidhe",
  "block.minecraft.yellow_stained_glass_pane": "Leòsan glainne buidhe",
  "block.minecraft.yellow_terracotta": "Terracotta buidhe",
  "block.minecraft.yellow_wool": "Clòimh bhuidhe",
  "block.minecraft.zombie_head": "Ceann cuirp-choisiche",
  "block.minecraft.zombie_wall_head": "Claigeann-balla cuirp-choisiche",
  "item.minecraft.acacia_boat": "Bàta sitta",
  "item.minecraft.acacia_chest_boat": "Bàta sitta le ciste",
  "item.minecraft.allay_spawn_egg": "Ugh gintinn foisich",
  "item.minecraft.amethyst_shard": "Sgealb amaitist",
  "item.minecraft.angler_pottery_shard": "Iasgair-slaite Pristeal Criadhadaireachd",
  "item.minecraft.angler_pottery_sherd": "Iasgair-slaite Brèaghach Criadhadaireachd",
  "item.minecraft.apple": "Ubhal",
  "item.minecraft.archer_pottery_shard": "Neach-bogha Pristeal Criadhadaireachd",
  "item.minecraft.archer_pottery_sherd": "Neach-bogha Brèaghach Criadhadaireachd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Sorchan armachd",
  "item.minecraft.arms_up_pottery_shard": "Gàirdeanan Suas Pristeal Criadhadaireachd",
  "item.minecraft.arms_up_pottery_sherd": "Gàirdeanan Suas Brèaghach Criadhadaireachd",
  "item.minecraft.arrow": "Saighead",
  "item.minecraft.axolotl_bucket": "Bucaid axolotl",
  "item.minecraft.axolotl_spawn_egg": "Ugh gintinn axolotl",
  "item.minecraft.baked_potato": "Buntàta àmhainne",
  "item.minecraft.bamboo_chest_raft": "Slaod bambù le ciste",
  "item.minecraft.bamboo_raft": "Slaod bambù",
  "item.minecraft.bat_spawn_egg": "Ugh gintinn ialtaig",
  "item.minecraft.bee_spawn_egg": "Ugh gintinn seillein",
  "item.minecraft.beef": "Mairtfheoil amh",
  "item.minecraft.beetroot": "Biatas",
  "item.minecraft.beetroot_seeds": "Sìl biatais",
  "item.minecraft.beetroot_soup": "Brot biatais",
  "item.minecraft.birch_boat": "Bàta beithe",
  "item.minecraft.birch_chest_boat": "Bàta beithe le ciste",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Dath dubh",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Liogh Pristeal Criadhadaireachd",
  "item.minecraft.blade_pottery_sherd": "Liogh Brèaghach Criadhadaireachd",
  "item.minecraft.blaze_powder": "Fùdar leòis",
  "item.minecraft.blaze_rod": "Slat leòis",
  "item.minecraft.blaze_spawn_egg": "Ugh gintinn leòis",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Dath gorm",
  "item.minecraft.blue_egg": "Ugh glas",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Ugh gintinn fear boglaich",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Cnàimh",
  "item.minecraft.bone_meal": "Min-chnàmha",
  "item.minecraft.book": "Leabhar",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Bogha",
  "item.minecraft.bowl": "Bobhla",
  "item.minecraft.bread": "Aran",
  "item.minecraft.breeze_rod": "Slat oiteige",
  "item.minecraft.breeze_spawn_egg": "Ugh gintinn oiteag",
  "item.minecraft.brewer_pottery_shard": "Grùdair Pristeal Criadhadaireachd",
  "item.minecraft.brewer_pottery_sherd": "Grùdair Brèaghach Criadhadaireachd",
  "item.minecraft.brewing_stand": "Inneal-grùdaireachd",
  "item.minecraft.brick": "Breige",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Dath donn",
  "item.minecraft.brown_egg": "Ugh ruadh",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Bruis",
  "item.minecraft.bucket": "Bucaid",
  "item.minecraft.bundle": "Pasgan",
  "item.minecraft.bundle.empty": "Falamh",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Làn",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Loisg Pristeal Criadhadaireachd",
  "item.minecraft.burn_pottery_sherd": "Loisg Brèaghach Criadhadaireachd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Ugh gintinn càmhal",
  "item.minecraft.carrot": "Curran",
  "item.minecraft.carrot_on_a_stick": "Bata agus curran air",
  "item.minecraft.cat_spawn_egg": "Ugh gintinn cait",
  "item.minecraft.cauldron": "Coire",
  "item.minecraft.cave_spider_spawn_egg": "Ugh gintinn damhain-allaidh uamha",
  "item.minecraft.chainmail_boots": "Bòtannan màilleach",
  "item.minecraft.chainmail_chestplate": "Lùireach mhàilleach",
  "item.minecraft.chainmail_helmet": "Clogaid mhàilleach",
  "item.minecraft.chainmail_leggings": "Briogais mhàilleach",
  "item.minecraft.charcoal": "Gual-fhiodha",
  "item.minecraft.cherry_boat": "Bàta siris",
  "item.minecraft.cherry_chest_boat": "Bàta ciris le ciste",
  "item.minecraft.chest_minecart": "Cairt-mhèinnearachd le ciste",
  "item.minecraft.chicken": "Cearc amh",
  "item.minecraft.chicken_spawn_egg": "Ugh gintinn circe",
  "item.minecraft.chorus_fruit": "Meas-sèiste",
  "item.minecraft.clay_ball": "Ball criadha",
  "item.minecraft.clock": "Uaireadair",
  "item.minecraft.coal": "Gual",
  "item.minecraft.coast_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Cnòthan-còco",
  "item.minecraft.cod": "Trosg amh",
  "item.minecraft.cod_bucket": "Trosg ann am bucaid",
  "item.minecraft.cod_spawn_egg": "Ugh gintinn truisg",
  "item.minecraft.command_block_minecart": "Cairt-mhèinnearachd le bloca-àithne",
  "item.minecraft.compass": "Combaist",
  "item.minecraft.cooked_beef": "Mairtfheoil ròiste",
  "item.minecraft.cooked_chicken": "Cearc ròiste",
  "item.minecraft.cooked_cod": "Trosg ròiste",
  "item.minecraft.cooked_mutton": "Feòil-chaorach ròiste",
  "item.minecraft.cooked_porkchop": "Muicfheoil ròiste",
  "item.minecraft.cooked_rabbit": "Feòil-choineanaich ròiste",
  "item.minecraft.cooked_salmon": "Bradan ròiste",
  "item.minecraft.cookie": "Briosgaid",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Unga copair",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Ugh gintinn bà",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Pàtran brataiche",
  "item.minecraft.creeper_banner_pattern.desc": "Aogas creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Ugh gintinn Creeper",
  "item.minecraft.crossbow": "Crois-bhogha",
  "item.minecraft.crossbow.projectile": "Astas:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Dath saidhean",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Cunnart Pristeal Criadhadaireachd",
  "item.minecraft.danger_pottery_sherd": "Cunnart Brèaghach Criadhadaireachd",
  "item.minecraft.dark_oak_boat": "Bàta daraich dhuirch",
  "item.minecraft.dark_oak_chest_boat": "Bàta daraich dhuirch le ciste",
  "item.minecraft.debug_stick": "Slat dì-bhugachaidh",
  "item.minecraft.debug_stick.empty": "Tha %s gun fheartan",
  "item.minecraft.debug_stick.select": "\"%s\" air a thaghadh (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" gu %s",
  "item.minecraft.diamond": "Daoimean",
  "item.minecraft.diamond_axe": "Tuagh daoimein",
  "item.minecraft.diamond_boots": "Bòtannan daoimein",
  "item.minecraft.diamond_chestplate": "Lùireach daoimein",
  "item.minecraft.diamond_helmet": "Clogaid daoimein",
  "item.minecraft.diamond_hoe": "Tobha daoimein",
  "item.minecraft.diamond_horse_armor": "Armachd eich daoimein",
  "item.minecraft.diamond_leggings": "Briogais daoimein",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Piocaid daoimein",
  "item.minecraft.diamond_shovel": "Sluasaid daoimein",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Claidheamh daoimein",
  "item.minecraft.disc_fragment_5": "Criomag Clàr",
  "item.minecraft.disc_fragment_5.desc": "Clàr-ciùil",
  "item.minecraft.dolphin_spawn_egg": "Ugh gintinn leumadair",
  "item.minecraft.donkey_spawn_egg": "Ugh ginntinn asail",
  "item.minecraft.dragon_breath": "Anail dràgoin",
  "item.minecraft.dried_kelp": "Ceilp thioramaichte",
  "item.minecraft.drowned_spawn_egg": "Ugh ginntinn bàithtich",
  "item.minecraft.dune_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Pristeal mac-alla",
  "item.minecraft.egg": "Ugh",
  "item.minecraft.elder_guardian_spawn_egg": "Ugh gintinn seann-fhreiceadain",
  "item.minecraft.elytra": "Sgiathanan",
  "item.minecraft.emerald": "Smàrag",
  "item.minecraft.enchanted_book": "Leabhar fo gheas",
  "item.minecraft.enchanted_golden_apple": "Ubhal òir fo gheas",
  "item.minecraft.end_crystal": "Criostal End",
  "item.minecraft.ender_dragon_spawn_egg": "Ugh gintinn dràgon crìochnaich",
  "item.minecraft.ender_eye": "Sùil Ender",
  "item.minecraft.ender_pearl": "Neamhnaid Ender",
  "item.minecraft.enderman_spawn_egg": "Ugh gintinn Enderman",
  "item.minecraft.endermite_spawn_egg": "Ugh gintinn Endermite",
  "item.minecraft.evoker_spawn_egg": "Ugh gintinn tairmeir",
  "item.minecraft.experience_bottle": "Searrag geasa",
  "item.minecraft.explorer_pottery_shard": "Taisgealach Pristeal Criadhadaireachd",
  "item.minecraft.explorer_pottery_sherd": "Taisgealach Brèaghach Criadhadaireachd",
  "item.minecraft.eye_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Ite",
  "item.minecraft.fermented_spider_eye": "Sùil damhain-allaidh bracha",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Bun teine",
  "item.minecraft.firework_rocket": "Rocaid cleasa-theine",
  "item.minecraft.firework_rocket.flight": "Faid an iteil:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Rionnag cleasa-theine",
  "item.minecraft.firework_star.black": "Dubh",
  "item.minecraft.firework_star.blue": "Gorm",
  "item.minecraft.firework_star.brown": "Donn",
  "item.minecraft.firework_star.custom_color": "Gnàthaichte",
  "item.minecraft.firework_star.cyan": "Saidhean",
  "item.minecraft.firework_star.fade_to": "Crìon gu",
  "item.minecraft.firework_star.flicker": "Priobadh",
  "item.minecraft.firework_star.gray": "Glas",
  "item.minecraft.firework_star.green": "Uaine",
  "item.minecraft.firework_star.light_blue": "Bàn-ghorm",
  "item.minecraft.firework_star.light_gray": "Liath",
  "item.minecraft.firework_star.lime": "Bàn-uaine",
  "item.minecraft.firework_star.magenta": "Maidèanta",
  "item.minecraft.firework_star.orange": "Orains",
  "item.minecraft.firework_star.pink": "Bàn-dearg",
  "item.minecraft.firework_star.purple": "Purpaidh",
  "item.minecraft.firework_star.red": "Dearg",
  "item.minecraft.firework_star.shape": "Cruth nach aithne dhuinn",
  "item.minecraft.firework_star.shape.burst": "Spreadhadh",
  "item.minecraft.firework_star.shape.creeper": "Air chruth creeper",
  "item.minecraft.firework_star.shape.large_ball": "Ball mòr",
  "item.minecraft.firework_star.shape.small_ball": "Ball beag",
  "item.minecraft.firework_star.shape.star": "Air chruth rionnaige",
  "item.minecraft.firework_star.trail": "Slighe",
  "item.minecraft.firework_star.white": "Geal",
  "item.minecraft.firework_star.yellow": "Buidhe",
  "item.minecraft.fishing_rod": "Slat-iasgaich",
  "item.minecraft.flint": "Clach-theine",
  "item.minecraft.flint_and_steel": "Clach-theine is stàilinn",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Pàtran brataiche",
  "item.minecraft.flower_banner_pattern.desc": "Aogas flùir",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Poit-fhlùir",
  "item.minecraft.fox_spawn_egg": "Ugh gintinn sionnaich",
  "item.minecraft.friend_pottery_shard": "Charaid Pristeal Criadhadaireachd",
  "item.minecraft.friend_pottery_sherd": "Charaid Brèaghach Criadhadaireachd",
  "item.minecraft.frog_spawn_egg": "Ugh gintinn losgann",
  "item.minecraft.furnace_minecart": "Cairt-mhèinnearachd le fùirneis",
  "item.minecraft.ghast_spawn_egg": "Ugh gintinn ghast",
  "item.minecraft.ghast_tear": "Deur ghast",
  "item.minecraft.glass_bottle": "Searrag glainne",
  "item.minecraft.glistering_melon_slice": "Sliseag meal-bhuic ghleansach",
  "item.minecraft.globe_banner_pattern": "Pàtran brataiche",
  "item.minecraft.globe_banner_pattern.desc": "Globa",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Dearcan dealraidh",
  "item.minecraft.glow_ink_sac": "Poca ince-dealraidh",
  "item.minecraft.glow_item_frame": "Frèam dealraidh",
  "item.minecraft.glow_squid_spawn_egg": "Ugh gintinn giobarnaich-dhealraidh",
  "item.minecraft.glowstone_dust": "Duslach cloiche-dealraidh",
  "item.minecraft.goat_horn": "Adhrac-reithe",
  "item.minecraft.goat_spawn_egg": "Ugh gintinn gobhair",
  "item.minecraft.gold_ingot": "Unga òir",
  "item.minecraft.gold_nugget": "Cnapan òir",
  "item.minecraft.golden_apple": "Ubhal òir",
  "item.minecraft.golden_axe": "Tuagh òir",
  "item.minecraft.golden_boots": "Bòtannan òir",
  "item.minecraft.golden_carrot": "Curran òir",
  "item.minecraft.golden_chestplate": "Lùireach òir",
  "item.minecraft.golden_helmet": "Clogaid òir",
  "item.minecraft.golden_hoe": "Tobha òir",
  "item.minecraft.golden_horse_armor": "Armachd eich òir",
  "item.minecraft.golden_leggings": "Briogais òir",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Piocaid òir",
  "item.minecraft.golden_shovel": "Sluasaid òir",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Claidheamh òir",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Dath glas",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Liath uaine",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Ugh gintinn freiceadain",
  "item.minecraft.gunpowder": "Fùdar-gunna",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Cridhe na mara",
  "item.minecraft.heart_pottery_shard": "Cridhe Pristeal Criadhadaireachd",
  "item.minecraft.heart_pottery_sherd": "Cridhe Brèaghach Criadhadaireachd",
  "item.minecraft.heartbreak_pottery_shard": "Cridhe-bris Pristeal Criadhadaireachd",
  "item.minecraft.heartbreak_pottery_sherd": "Cridhe-bris Brèaghach Criadhadaireachd",
  "item.minecraft.hoglin_spawn_egg": "Ugh gintinn hoglin",
  "item.minecraft.honey_bottle": "Botal meala",
  "item.minecraft.honeycomb": "Cìr-mheala",
  "item.minecraft.hopper_minecart": "Cairt-mhèinnearachd le drabhailt",
  "item.minecraft.horse_spawn_egg": "Ugh gintinn eich",
  "item.minecraft.host_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Donnal Pristeal Criadhadaireachd",
  "item.minecraft.howl_pottery_sherd": "Donnal Brèaghach Criadhadaireachd",
  "item.minecraft.husk_spawn_egg": "Ugh gintinn mogail",
  "item.minecraft.ink_sac": "Poca-ince",
  "item.minecraft.iron_axe": "Tuagh iarainn",
  "item.minecraft.iron_boots": "Bòtannan iarainn",
  "item.minecraft.iron_chestplate": "Lùireach iarainn",
  "item.minecraft.iron_golem_spawn_egg": "Ugh ginntin gòileam iarainn",
  "item.minecraft.iron_helmet": "Clogaid iarainn",
  "item.minecraft.iron_hoe": "Tobha iarainn",
  "item.minecraft.iron_horse_armor": "Armachd eich iarainn",
  "item.minecraft.iron_ingot": "Unga iarainn",
  "item.minecraft.iron_leggings": "Briogais iarainn",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Cnapan iarainn",
  "item.minecraft.iron_pickaxe": "Piocaid iarainn",
  "item.minecraft.iron_shovel": "Sluasaid iarainn",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Claidheamh iarainn",
  "item.minecraft.item_frame": "Frèam",
  "item.minecraft.jungle_boat": "Bàta dlùth-choille",
  "item.minecraft.jungle_chest_boat": "Bàta dlùth-choille le ciste",
  "item.minecraft.knowledge_book": "Leabhar-eòlais",
  "item.minecraft.lapis_lazuli": "Clach-chopair",
  "item.minecraft.lava_bucket": "Bucaid làbha",
  "item.minecraft.lead": "Taod",
  "item.minecraft.leather": "Leathar",
  "item.minecraft.leather_boots": "Bòtannan leathair",
  "item.minecraft.leather_chestplate": "Lèine leathair",
  "item.minecraft.leather_helmet": "Currac leathair",
  "item.minecraft.leather_horse_armor": "Armachd eich leathair",
  "item.minecraft.leather_leggings": "Briogais leathair",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Dath bàn-ghorm",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Dath liath",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Dath bàn-uaine",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Deoch-fhuireachd",
  "item.minecraft.lingering_potion.effect.awkward": "Deoch-fhuireachd lapach",
  "item.minecraft.lingering_potion.effect.empty": "Deoch-fhuireachd nach gabh dèanamh le ceàrd",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Deoch-fhuireachd gu seasamh an aghaidh teine",
  "item.minecraft.lingering_potion.effect.harming": "Deoch-fhuireachd an dochainn",
  "item.minecraft.lingering_potion.effect.healing": "Deoch-fhuireachd an t-slànachaidh",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Deoch-fhuireachd do-fhaicsinneachd",
  "item.minecraft.lingering_potion.effect.leaping": "Deoch-fhuireachd nan leum",
  "item.minecraft.lingering_potion.effect.levitation": "Deoch-fhuireachd na togalach suas",
  "item.minecraft.lingering_potion.effect.luck": "Deoch-fhuireachd an fhortain",
  "item.minecraft.lingering_potion.effect.mundane": "Deoch-fhuireachd shaoghalta",
  "item.minecraft.lingering_potion.effect.night_vision": "Deoch-fhuireachd an fhradhairc-oidhche",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Deoch-fhuireachd phuinnseanta",
  "item.minecraft.lingering_potion.effect.regeneration": "Deoch-fhuireachd ath-ghintinn",
  "item.minecraft.lingering_potion.effect.slow_falling": "Deoch-fhuireachd tuiteim shlaodaich",
  "item.minecraft.lingering_potion.effect.slowness": "Deoch-fhuireachd na maille",
  "item.minecraft.lingering_potion.effect.strength": "Deoch-fhuireachd an neirt",
  "item.minecraft.lingering_potion.effect.swiftness": "Deoch-fhuireachd an luathais",
  "item.minecraft.lingering_potion.effect.thick": "Deoch-fhuireachd thiugh",
  "item.minecraft.lingering_potion.effect.turtle_master": "Deoch-fhuireachd a' chinn-thurtaran",
  "item.minecraft.lingering_potion.effect.water": "Searrag le uisge-fuireachd",
  "item.minecraft.lingering_potion.effect.water_breathing": "Deoch-fhuireachd na h-analach-uisge",
  "item.minecraft.lingering_potion.effect.weakness": "Deoch-fhuireachd na laigse",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Ugh gintinn llama",
  "item.minecraft.lodestone_compass": "Combaist cloiche-iùil",
  "item.minecraft.mace": "Màs",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Dath maidèanta",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Cè magma",
  "item.minecraft.magma_cube_spawn_egg": "Ugh gintinn ciùba-mhagma",
  "item.minecraft.mangrove_boat": "Bàta mangarbh",
  "item.minecraft.mangrove_chest_boat": "Bàta mangarbh le ciste",
  "item.minecraft.map": "Mapa falamh",
  "item.minecraft.melon_seeds": "Sìl meal-bhuic",
  "item.minecraft.melon_slice": "Sliseag meal-bhuic",
  "item.minecraft.milk_bucket": "Bucaid bainne",
  "item.minecraft.minecart": "Cairt-mhèinnearachd",
  "item.minecraft.miner_pottery_shard": "Mèinneadair Pristeal Criadhadaireachd",
  "item.minecraft.miner_pottery_sherd": "Mèinneadair Brèaghach Criadhadaireachd",
  "item.minecraft.mojang_banner_pattern": "Pàtran brataiche",
  "item.minecraft.mojang_banner_pattern.desc": "Rud",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Ugh gintinn Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Neach-caoidhe Pristeal Criadhadaireachd",
  "item.minecraft.mourner_pottery_sherd": "Neach-caoidhe Brèaghach Criadhadaireachd",
  "item.minecraft.mule_spawn_egg": "Ugh gintinn leth-asail",
  "item.minecraft.mushroom_stew": "Stiubha balgain-bhuachair",
  "item.minecraft.music_disc_11": "Clàr Ceòl",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Clàr ciùil",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Clàr Ceòl",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Clàr Ceòl",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Clàr Ceòl",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Clàr Ceòl",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Clàr Ceòl",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Clàr Ceòl",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Clàr Ceòl",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Clàr Ceòl",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Clàr Ceòl",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pig cheum",
  "item.minecraft.music_disc_precipice": "Clàr-ciùil",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Clàr Ceòl",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Clàr Ceòl",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Clàr Ceòl",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Clàr Ceòl",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Clàr Ceòl",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Feòil-chaorach amh",
  "item.minecraft.name_tag": "Taga ainme",
  "item.minecraft.nautilus_shell": "Slige faochaige",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Breige Nether",
  "item.minecraft.nether_star": "Rionnag Nether",
  "item.minecraft.nether_wart": "Fuinne Nether",
  "item.minecraft.netherite_axe": "Tuagh netherit",
  "item.minecraft.netherite_boots": "Bòtannan netherit",
  "item.minecraft.netherite_chestplate": "Lùireach netherit",
  "item.minecraft.netherite_helmet": "Clogaid netherit",
  "item.minecraft.netherite_hoe": "Tobha netherit",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Unga netherit",
  "item.minecraft.netherite_leggings": "Briogais netherit",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Piocaid netherit",
  "item.minecraft.netherite_scrap": "Criomag netherit",
  "item.minecraft.netherite_shovel": "Sluasaid netherit",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Claidheamh netherit",
  "item.minecraft.netherite_upgrade_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Bàta daraich",
  "item.minecraft.oak_chest_boat": "Bàta darach le ciste",
  "item.minecraft.ocelot_spawn_egg": "Ugh gintinn cait fhiadhaich",
  "item.minecraft.ominous_bottle": "Botal bagrach",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Dath orains",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Dealbh",
  "item.minecraft.pale_oak_boat": "Bàta daraich bhàin",
  "item.minecraft.pale_oak_chest_boat": "Bàta daraich bhàin le ciste",
  "item.minecraft.panda_spawn_egg": "Ugh gintinn panda",
  "item.minecraft.paper": "Pàipear",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Ugh gintinn pearraid",
  "item.minecraft.phantom_membrane": "Meamran tannaisg",
  "item.minecraft.phantom_spawn_egg": "Ugh gintinn tannaisg",
  "item.minecraft.pig_spawn_egg": "Ugh gintinn muice",
  "item.minecraft.piglin_banner_pattern": "Pàtran brataiche",
  "item.minecraft.piglin_banner_pattern.desc": "Gnos",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Ugh gintinn brùide piglin",
  "item.minecraft.piglin_spawn_egg": "Ugh gintinn piglin",
  "item.minecraft.pillager_spawn_egg": "Ugh gintinn spùinneadair",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Dath bàn-dearg",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Lus-pige",
  "item.minecraft.pitcher_pod": "Meilgeag lus-pige",
  "item.minecraft.plenty_pottery_shard": "Lìonmhorachd Pristeal Criadhadaireachd",
  "item.minecraft.plenty_pottery_sherd": "Lìonmhorachd Brèaghach Criadhadaireachd",
  "item.minecraft.poisonous_potato": "Buntàta puinnseanta",
  "item.minecraft.polar_bear_spawn_egg": "Ugh gintinn mathain-bhàin",
  "item.minecraft.popped_chorus_fruit": "Meas-sèiste briste",
  "item.minecraft.porkchop": "Muicfheoil amh",
  "item.minecraft.potato": "Buntàta",
  "item.minecraft.potion": "Deoch",
  "item.minecraft.potion.effect.awkward": "Deoch lapach",
  "item.minecraft.potion.effect.empty": "Deoch nach gabh dèanamh le ceàrd",
  "item.minecraft.potion.effect.fire_resistance": "Deoch gu seasamh an aghaidh teine",
  "item.minecraft.potion.effect.harming": "Deoch an dochainn",
  "item.minecraft.potion.effect.healing": "Deoch an t-slànachaidh",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Deoch do-fhaicsinneachd",
  "item.minecraft.potion.effect.leaping": "Deoch nan leum",
  "item.minecraft.potion.effect.levitation": "Deoch na togalach suas",
  "item.minecraft.potion.effect.luck": "Deoch an fhortain",
  "item.minecraft.potion.effect.mundane": "Deoch shaoghalta",
  "item.minecraft.potion.effect.night_vision": "Deoch an fhradhairc-oidhche",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Deoch phuinnseanta",
  "item.minecraft.potion.effect.regeneration": "Deoch ath-ghintinn",
  "item.minecraft.potion.effect.slow_falling": "Deoch tuiteim shlaodaich",
  "item.minecraft.potion.effect.slowness": "Deoch na maille",
  "item.minecraft.potion.effect.strength": "Deoch an neirt",
  "item.minecraft.potion.effect.swiftness": "Deoch an luathais",
  "item.minecraft.potion.effect.thick": "Deoch thiugh",
  "item.minecraft.potion.effect.turtle_master": "Deoch a' chinn-thurtaran",
  "item.minecraft.potion.effect.water": "Searrag le uisge",
  "item.minecraft.potion.effect.water_breathing": "Deoch na h-analach-uisge",
  "item.minecraft.potion.effect.weakness": "Deoch na laigse",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Neach-bogha Pristeal Criadhadaireachd",
  "item.minecraft.pottery_shard_arms_up": "Gàirdeanan Suas Pristeal Criadhadaireachd",
  "item.minecraft.pottery_shard_prize": "Duais Pristeal Criadhadaireachd",
  "item.minecraft.pottery_shard_skull": "Claigeann Pristeal Criadhadaireachd",
  "item.minecraft.powder_snow_bucket": "Bucaid sneachda mhìn-phruinn",
  "item.minecraft.prismarine_crystals": "Criostalan priosaim-mhara",
  "item.minecraft.prismarine_shard": "Sgealb priosaim-mhara",
  "item.minecraft.prize_pottery_shard": "Duais Pristeal Criadhadaireachd",
  "item.minecraft.prize_pottery_sherd": "Duais Brèaghach Criadhadaireachd",
  "item.minecraft.pufferfish": "Iasg-sèididh",
  "item.minecraft.pufferfish_bucket": "Iasg-sèididh ann am bucaid",
  "item.minecraft.pufferfish_spawn_egg": "Ugh gintinn èisg-shèididh",
  "item.minecraft.pumpkin_pie": "Pàidh peapaige",
  "item.minecraft.pumpkin_seeds": "Sìl peapaige",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Dath purpaidh",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Eiteag Nether",
  "item.minecraft.rabbit": "Feòil-choineanaich amh",
  "item.minecraft.rabbit_foot": "Cas coineanaich",
  "item.minecraft.rabbit_hide": "Bian coineanaich",
  "item.minecraft.rabbit_spawn_egg": "Ugh gintinn coineanaich",
  "item.minecraft.rabbit_stew": "Stiubha coineanaich",
  "item.minecraft.raiser_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Ugh gintinn creachadair",
  "item.minecraft.raw_copper": "Copar amh",
  "item.minecraft.raw_gold": "Òr amh",
  "item.minecraft.raw_iron": "Iarann ​​amh",
  "item.minecraft.recovery_compass": "Combaist Ath-shlànachadh",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Dath dearg",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Duslach redstone",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Feòil lobhta",
  "item.minecraft.saddle": "Dìollaid",
  "item.minecraft.salmon": "Bradan amh",
  "item.minecraft.salmon_bucket": "Bradan ann am bucaid",
  "item.minecraft.salmon_spawn_egg": "Ugh gintinn bradain",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Raoide Pristeal Criadhadaireachd",
  "item.minecraft.sheaf_pottery_sherd": "Raoide Brèaghach Criadhadaireachd",
  "item.minecraft.shears": "Deamhas",
  "item.minecraft.sheep_spawn_egg": "Ugh gintinn caorach",
  "item.minecraft.shelter_pottery_shard": "Fàthachd Pristeal Criadhadaireachd",
  "item.minecraft.shelter_pottery_sherd": "Fàthachd Brèaghach Criadhadaireachd",
  "item.minecraft.shield": "Sgiath",
  "item.minecraft.shield.black": "Sgiath dhubh",
  "item.minecraft.shield.blue": "Sgiath ghorm",
  "item.minecraft.shield.brown": "Sgiath dhonn",
  "item.minecraft.shield.cyan": "Sgiath shaidhean",
  "item.minecraft.shield.gray": "Sgiath ghlas",
  "item.minecraft.shield.green": "Sgiath uaine",
  "item.minecraft.shield.light_blue": "Sgiath bhàn-ghorm",
  "item.minecraft.shield.light_gray": "Sgiath liath",
  "item.minecraft.shield.lime": "Sgiath bhàn-uaine",
  "item.minecraft.shield.magenta": "Sgiath mhaidèanta",
  "item.minecraft.shield.orange": "Sgiath orains",
  "item.minecraft.shield.pink": "Sgiath bhàn-dearg",
  "item.minecraft.shield.purple": "Sgiath phurpaidh",
  "item.minecraft.shield.red": "Sgiath dhearg",
  "item.minecraft.shield.white": "Sgiath gheal",
  "item.minecraft.shield.yellow": "Sgiath bhuidhe",
  "item.minecraft.shulker_shell": "Slige shulker",
  "item.minecraft.shulker_spawn_egg": "Ugh gintinn shulker",
  "item.minecraft.sign": "Soidhne",
  "item.minecraft.silence_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Ugh gintinn fiolain-ghlais",
  "item.minecraft.skeleton_horse_spawn_egg": "Ugh gintinn eich-chnàimhnich",
  "item.minecraft.skeleton_spawn_egg": "Ugh gintinn cnàimhnich",
  "item.minecraft.skull_banner_pattern": "Pàtran brataiche",
  "item.minecraft.skull_banner_pattern.desc": "Aogas claiginn",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Claigeann Pristeal Criadhadaireachd",
  "item.minecraft.skull_pottery_sherd": "Claigeann Brèaghach Criadhadaireachd",
  "item.minecraft.slime_ball": "Ball eabair",
  "item.minecraft.slime_spawn_egg": "Ugh gintinn eabair",
  "item.minecraft.smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.smithing_template.applies_to": "A' buntainn ri:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Cuir unga no criostal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armachd",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Cuir a pìos armachd",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ungan ⁊ Criostalan",
  "item.minecraft.smithing_template.ingredients": "Tàthchuidean:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Cuir unga netherit",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Uidheam Daoimean",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Cuir armachd, ball-airm, no inneal daoimean",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Unga netherit",
  "item.minecraft.smithing_template.upgrade": "Àrdaich: ",
  "item.minecraft.sniffer_spawn_egg": "Ugh gintinn snotair",
  "item.minecraft.snort_pottery_shard": "Pludar Pristeal Criadhadaireachd",
  "item.minecraft.snort_pottery_sherd": "Pludar Brèaghach Criadhadaireachd",
  "item.minecraft.snout_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Ugh ginntin gòileam sneachd",
  "item.minecraft.snowball": "Ball-sneachda",
  "item.minecraft.spectral_arrow": "Saighead luisnidh",
  "item.minecraft.spider_eye": "Sùil damhain-allaidh",
  "item.minecraft.spider_spawn_egg": "Ugh gintinn damhain-allaidh",
  "item.minecraft.spire_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Deoch-thilgidh",
  "item.minecraft.splash_potion.effect.awkward": "Deoch-thilgidh lapach",
  "item.minecraft.splash_potion.effect.empty": "Deoch-thilgidh nach gabh dèanamh le ceàrd",
  "item.minecraft.splash_potion.effect.fire_resistance": "Deoch-thilgidh gu seasamh an aghaidh teine",
  "item.minecraft.splash_potion.effect.harming": "Deoch-thilgidh an dochainn",
  "item.minecraft.splash_potion.effect.healing": "Deoch-thilgidh an t-slànachaidh",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Deoch-thilgidh do-fhaicsinneachd",
  "item.minecraft.splash_potion.effect.leaping": "Deoch-thilgidh nan leum",
  "item.minecraft.splash_potion.effect.levitation": "Deoch-thilgidh na togalach suas",
  "item.minecraft.splash_potion.effect.luck": "Deoch-thilgidh an fhortain",
  "item.minecraft.splash_potion.effect.mundane": "Deoch-thilgidh shaoghalta",
  "item.minecraft.splash_potion.effect.night_vision": "Deoch-thilgidh an fhradhairc-oidhche",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Deoch-thilgidh phuinnseanta",
  "item.minecraft.splash_potion.effect.regeneration": "Deoch-thilgidh ath-ghintinn",
  "item.minecraft.splash_potion.effect.slow_falling": "Deoch-thilgidh tuiteim shlaodaich",
  "item.minecraft.splash_potion.effect.slowness": "Deoch-thilgidh na maille",
  "item.minecraft.splash_potion.effect.strength": "Deoch-thilgidh an neirt",
  "item.minecraft.splash_potion.effect.swiftness": "Deoch-thilgidh an luathais",
  "item.minecraft.splash_potion.effect.thick": "Deoch-thilgidh thiugh",
  "item.minecraft.splash_potion.effect.turtle_master": "Deoch-thilgidh a' chinn-thurtaran",
  "item.minecraft.splash_potion.effect.water": "Searrag-thilgidh le uisge",
  "item.minecraft.splash_potion.effect.water_breathing": "Deoch-thilgidh na h-analach-uisge",
  "item.minecraft.splash_potion.effect.weakness": "Deoch-thilgidh na laigse",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Bàta giuthais",
  "item.minecraft.spruce_chest_boat": "Bàta giuthais le ciste",
  "item.minecraft.spyglass": "Prosbaig",
  "item.minecraft.squid_spawn_egg": "Ugh gintinn giobarnaich",
  "item.minecraft.stick": "Bata",
  "item.minecraft.stone_axe": "Tuagh cloiche",
  "item.minecraft.stone_hoe": "Tobha cloiche",
  "item.minecraft.stone_pickaxe": "Piocaid cloiche",
  "item.minecraft.stone_shovel": "Sluasaid cloiche",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Claidheamh cloiche",
  "item.minecraft.stray_spawn_egg": "Ugh gintinn conadail",
  "item.minecraft.strider_spawn_egg": "Ugh gintinn ceumaiche",
  "item.minecraft.string": "Sreang",
  "item.minecraft.sugar": "Siùcar",
  "item.minecraft.suspicious_stew": "Stiubha amharasach",
  "item.minecraft.sweet_berries": "Dearcan milis",
  "item.minecraft.tadpole_bucket": "Ceann-simid ann am bucaid",
  "item.minecraft.tadpole_spawn_egg": "Ugh gintinn ceann-simid",
  "item.minecraft.tide_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Saighead agus seun oirre",
  "item.minecraft.tipped_arrow.effect.awkward": "Saighead Dheoch",
  "item.minecraft.tipped_arrow.effect.empty": "Saighead sheunta nach dèanar le obair-chiùird",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Saighead gu seasamh an aghaidh teine",
  "item.minecraft.tipped_arrow.effect.harming": "Saighead an dochainn",
  "item.minecraft.tipped_arrow.effect.healing": "Saighead an t-slànachaidh",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Saighead na do-fhaicsinneachd",
  "item.minecraft.tipped_arrow.effect.leaping": "Saighead nan leum",
  "item.minecraft.tipped_arrow.effect.levitation": "Saighead na togalach suas",
  "item.minecraft.tipped_arrow.effect.luck": "Saighead an fhortain",
  "item.minecraft.tipped_arrow.effect.mundane": "Saighead Dheoch",
  "item.minecraft.tipped_arrow.effect.night_vision": "Saighead an fhradhairc-oidhche",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Saighead phuinnseanta",
  "item.minecraft.tipped_arrow.effect.regeneration": "Saighead ath-ghintinn",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Saighead tuiteim shlaodaich",
  "item.minecraft.tipped_arrow.effect.slowness": "Saighead na maille",
  "item.minecraft.tipped_arrow.effect.strength": "Saighead an neirt",
  "item.minecraft.tipped_arrow.effect.swiftness": "Saighead an luathais",
  "item.minecraft.tipped_arrow.effect.thick": "Saighead Dheoch",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Saighead a' chinn-thurtaran",
  "item.minecraft.tipped_arrow.effect.water": "Saighead an uisge",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Saighead na h-analach-uisge",
  "item.minecraft.tipped_arrow.effect.weakness": "Saighead na laigse",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Cairt-mhèinnearachd le TNT",
  "item.minecraft.torchflower_seeds": "Sìl fhlùir-lòchran",
  "item.minecraft.totem_of_undying": "Tòtam dìona o bhàs",
  "item.minecraft.trader_llama_spawn_egg": "Ugh gintinn llama marsanta",
  "item.minecraft.trial_key": "Iuchair an Àite-deuchainn",
  "item.minecraft.trident": "Muirgheadh",
  "item.minecraft.tropical_fish": "Iasg tropaigeach",
  "item.minecraft.tropical_fish_bucket": "Iasg tropaigeach ann am bucaid",
  "item.minecraft.tropical_fish_spawn_egg": "Ugh gintinn èisg thropaigich",
  "item.minecraft.turtle_helmet": "Cochall turtair",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Ugh gintinn turtair",
  "item.minecraft.vex_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Ugh gintinn buaireadair",
  "item.minecraft.villager_spawn_egg": "Ugh gintinn saoranaich",
  "item.minecraft.vindicator_spawn_egg": "Ugh gintinn tagaire",
  "item.minecraft.wandering_trader_spawn_egg": "Ugh gintinn marsanta allabanaich",
  "item.minecraft.ward_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Ugh gintinn uàrdan",
  "item.minecraft.warped_fungus_on_a_stick": "Fungas saobh air bata",
  "item.minecraft.water_bucket": "Bucaid uisge",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Cruithneachd",
  "item.minecraft.wheat_seeds": "Sìl cruithneachd",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Dath geal",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Teamplaid goibhneachd",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Ugh gintinn bana-bhuidsiche",
  "item.minecraft.wither_skeleton_spawn_egg": "Ugh gintinn wither-chnàimhnich",
  "item.minecraft.wither_spawn_egg": "Ugh gintinn crìon",
  "item.minecraft.wolf_armor": "Armachd coin",
  "item.minecraft.wolf_spawn_egg": "Ugh gintinn madaidh-allaidh",
  "item.minecraft.wooden_axe": "Tuagh fiodha",
  "item.minecraft.wooden_hoe": "Tobha fiodha",
  "item.minecraft.wooden_pickaxe": "Piocaid fiodha",
  "item.minecraft.wooden_shovel": "Sluasaid fiodha",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Claidheamh fiodha",
  "item.minecraft.writable_book": "Leabhar is cleit",
  "item.minecraft.written_book": "Leabhar sgrìobhte",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Dath buidhe",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Ugh gintinn zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ugh gintinn cuirp-eich",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Ugh gintinn cuirp-choisiche",
  "item.minecraft.zombie_villager_spawn_egg": "Ugh gintinn corp-coisiche saoranaich",
  "item.minecraft.zombified_piglin_spawn_egg": "Ugh gintinn piglin"
}
export const gd_gb = items; 
